//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ActionTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedActionTypes(body: PagedRequestDto | undefined): Observable<ActionTypeDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/ActionTypes/GetPagedActionTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedActionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedActionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionTypeDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionTypeDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedActionTypes(response: HttpResponseBase): Observable<ActionTypeDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionTypeDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionTypeDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllActionTypes(): Observable<ActionTypeDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/ActionTypes/GetAllActionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionTypeDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionTypeDtoListServiceResponse>;
        }));
    }

    protected processGetAllActionTypes(response: HttpResponseBase): Observable<ActionTypeDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionTypeDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionTypeDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createActionType(body: ActionTypeCreateDto | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/ActionTypes/CreateActionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateActionType(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getActionTypeById(id: number): Observable<ActionTypeDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/ActionTypes/GetActionTypeById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActionTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionTypeDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionTypeDtoServiceResponse>;
        }));
    }

    protected processGetActionTypeById(response: HttpResponseBase): Observable<ActionTypeDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionTypeDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionTypeDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateActionType(body: ActionTypeUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/ActionTypes/UpdateActionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateActionType(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteActionType(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/ActionTypes/DeleteActionType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteActionType(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AuditLogCreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AuditLogs/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/AuditLogs/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/AuditLogs/getById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AuditLogUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AuditLogs/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/AuditLogs/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginModel | undefined): Observable<LoginReaponseServiceResponse> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginReaponseServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginReaponseServiceResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginReaponseServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginReaponseServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = LoginReaponseServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DepartmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedDepartments(body: PagedRequestDto | undefined): Observable<DepartmentPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Departments/GetPagedDepartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedDepartments(response: HttpResponseBase): Observable<DepartmentPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DepartmentPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllDepartments(): Observable<DepartmentDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/Departments/GetAllDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDtoListServiceResponse>;
        }));
    }

    protected processGetAllDepartments(response: HttpResponseBase): Observable<DepartmentDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DepartmentDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDepartment(body: DepartmentCreateDto | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Departments/createDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateDepartment(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDepartmentById(id: number): Observable<DepartmentDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Departments/GetDepartmentById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDtoServiceResponse>;
        }));
    }

    protected processGetDepartmentById(response: HttpResponseBase): Observable<DepartmentDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DepartmentDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDepartment(body: DepartmentUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Departments/updateDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateDepartment(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteDepartment(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Departments/deleteDepartment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteDepartment(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentMetadataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create2(body: DocumentMetadataCreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentMetadata/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: number | undefined): Observable<DocumentMetadataDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/DocumentMetadata/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentMetadataDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentMetadataDtoListServiceResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentMetadataDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentMetadataDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DocumentMetadataDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = DocumentMetadataDtoListServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentMetadata/getById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update2(body: DocumentMetadataUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentMetadata/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    delete2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentMetadata/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocumentTypesPaged(body: PagedRequestDto | undefined): Observable<DocumentTypeDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/GetDocumentTypesPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypesPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypesPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetDocumentTypesPaged(response: HttpResponseBase): Observable<DocumentTypeDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DocumentTypeDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedDocuments(body: FolderPagedRequestDto | undefined): Observable<DocumentDtoFolderPageResponseServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/GetPagedDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDtoFolderPageResponseServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDtoFolderPageResponseServiceResponse>;
        }));
    }

    protected processGetPagedDocuments(response: HttpResponseBase): Observable<DocumentDtoFolderPageResponseServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDtoFolderPageResponseServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DocumentDtoFolderPageResponseServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedFoldersAndSubFolder(body: FolderPagedRequestDto | undefined): Observable<DocumentDtoFolderPageResponseServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/GetPagedFoldersAndSubFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedFoldersAndSubFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedFoldersAndSubFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDtoFolderPageResponseServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDtoFolderPageResponseServiceResponse>;
        }));
    }

    protected processGetPagedFoldersAndSubFolder(response: HttpResponseBase): Observable<DocumentDtoFolderPageResponseServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDtoFolderPageResponseServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DocumentDtoFolderPageResponseServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSharedLink(body: SharedLinkCreateDto | undefined): Observable<ObjectServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/createSharedLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSharedLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSharedLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectServiceResponse>;
        }));
    }

    protected processCreateSharedLink(response: HttpResponseBase): Observable<ObjectServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ObjectServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllDocumentTypes(): Observable<DocumentTypeDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/getAllDocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDtoListServiceResponse>;
        }));
    }

    protected processGetAllDocumentTypes(response: HttpResponseBase): Observable<DocumentTypeDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DocumentTypeDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteDocumentType(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/DeleteDocumentType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteDocumentType(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Int32NullableServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteDocument(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/DeleteDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Int32NullableServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDocumentWithDocumentVersions(body: DocumwntWithDocumentVersionCreate | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/CreateDocumentWithDocumentVersions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDocumentWithDocumentVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDocumentWithDocumentVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateDocumentWithDocumentVersions(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocument(body: DocumentUpdate | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/updateDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateDocument(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOcrText(documentVersionId: number): Observable<StringServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/GetOcrText/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOcrText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOcrText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringServiceResponse>;
        }));
    }

    protected processGetOcrText(response: HttpResponseBase): Observable<StringServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = StringServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocumentDetailsById(body: number | undefined): Observable<DocumentDetailsDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/getDocumentDetailsById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetailsDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetailsDtoServiceResponse>;
        }));
    }

    protected processGetDocumentDetailsById(response: HttpResponseBase): Observable<DocumentDetailsDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetailsDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DocumentDetailsDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = DocumentDetailsDtoServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkSharedLink(hashedshareLinkId: string): Observable<SharedLinkDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/checkSharedLink/{HashedshareLinkId}";
        if (hashedshareLinkId === undefined || hashedshareLinkId === null)
            throw new Error("The parameter 'hashedshareLinkId' must be defined.");
        url_ = url_.replace("{HashedshareLinkId}", encodeURIComponent("" + hashedshareLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSharedLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSharedLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedLinkDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedLinkDtoServiceResponse>;
        }));
    }

    protected processCheckSharedLink(response: HttpResponseBase): Observable<SharedLinkDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SharedLinkDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dockey (optional) 
     * @param body (optional) 
     * @return Success
     */
    getDocumentDetailsByDocVersionId(dockey: string | undefined, body: string | undefined): Observable<DocumentVersionDetailsDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Documents/getDocumentDetailsByDocVersionId?";
        if (dockey === null)
            throw new Error("The parameter 'dockey' cannot be null.");
        else if (dockey !== undefined)
            url_ += "Dockey=" + encodeURIComponent("" + dockey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentDetailsByDocVersionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentDetailsByDocVersionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentVersionDetailsDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentVersionDetailsDtoServiceResponse>;
        }));
    }

    protected processGetDocumentDetailsByDocVersionId(response: HttpResponseBase): Observable<DocumentVersionDetailsDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentVersionDetailsDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DocumentVersionDetailsDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = DocumentVersionDetailsDtoServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentTagsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create3(body: DocumentTagCreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentTags/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll2(): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/DocumentTags/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processGetAll2(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param tagId (optional) 
     * @return Success
     */
    getByKey(documentId: number | undefined, tagId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentTags/getByKey?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetByKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update3(body: DocumentTagUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentTags/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param tagId (optional) 
     * @return Success
     */
    delete3(documentId: number | undefined, tagId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentTags/delete?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentVersionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll3(): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentVersions/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAll3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById3(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentVersions/getById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update4(body: DocumentVersionUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentVersions/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    delete4(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentVersions/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteEmployee(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Employee/DeleteEmployee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteEmployee(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(body: EmployeeUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Employee/updateEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateEmployee(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmployee(body: EmployeeCreateDto | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Employee/createEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateEmployee(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedEmployees(body: PagedRequestDto | undefined): Observable<EmployeeDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Employee/GetPagedEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedEmployees(response: HttpResponseBase): Observable<EmployeeDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = EmployeeDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllEmployees(body: EmployeeFilterDto | undefined): Observable<EmployeeDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/Employee/GetAllEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDtoListServiceResponse>;
        }));
    }

    protected processGetAllEmployees(response: HttpResponseBase): Observable<EmployeeDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = EmployeeDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileCategoriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedFileCategories(body: PagedRequestDto | undefined): Observable<FileCategoryDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/FileCategories/GetPagedFileCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedFileCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedFileCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileCategoryDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileCategoryDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedFileCategories(response: HttpResponseBase): Observable<FileCategoryDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileCategoryDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FileCategoryDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllFileCategories(): Observable<FileCategoryDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/FileCategories/GetAllFileCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFileCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFileCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileCategoryDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileCategoryDtoListServiceResponse>;
        }));
    }

    protected processGetAllFileCategories(response: HttpResponseBase): Observable<FileCategoryDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileCategoryDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FileCategoryDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFileCategory(body: FileCategoryCreateDto | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/FileCategories/createFileCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFileCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFileCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateFileCategory(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFileCategoryById(id: number): Observable<FileCategoryDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/FileCategories/GetFileCategoryById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileCategoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileCategoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileCategoryDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileCategoryDtoServiceResponse>;
        }));
    }

    protected processGetFileCategoryById(response: HttpResponseBase): Observable<FileCategoryDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileCategoryDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FileCategoryDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFileCategory(body: FileCategoryUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/FileCategories/updateFileCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFileCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFileCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateFileCategory(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteFileCategory(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/FileCategories/deleteFileCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFileCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFileCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteFileCategory(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FoldersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedFolders(body: FolderPagedRequestDto | undefined): Observable<FolderPageResponseServiceResponse> {
        let url_ = this.baseUrl + "/api/Folders/GetPagedFolders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedFolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedFolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FolderPageResponseServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FolderPageResponseServiceResponse>;
        }));
    }

    protected processGetPagedFolders(response: HttpResponseBase): Observable<FolderPageResponseServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FolderPageResponseServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FolderPageResponseServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFolder(body: FolderCreateDto | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Folders/createFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateFolder(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IncomingMailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteIncoming(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/IncomingMail/deleteIncoming/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteIncoming(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteIncoming(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteIncoming(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIncomingMailById(id: number): Observable<IncomingMailDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/IncomingMail/GetIncomingMailById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomingMailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomingMailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomingMailDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomingMailDtoServiceResponse>;
        }));
    }

    protected processGetIncomingMailById(response: HttpResponseBase): Observable<IncomingMailDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomingMailDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = IncomingMailDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createIncomingMail(body: IncomingMailWithAttachmentsCreate | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/IncomingMail/CreateIncomingMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIncomingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIncomingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processCreateIncomingMail(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIncomingMail(body: IncomingMailWithAttachmentsUpdate | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/IncomingMail/UpdateIncomingMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIncomingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIncomingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateIncomingMail(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedIncomingMails(body: IncomingMailPagedRequestDto | undefined): Observable<IncomingMailPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/IncomingMail/GetPagedIncomingMails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedIncomingMails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedIncomingMails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomingMailPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomingMailPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedIncomingMails(response: HttpResponseBase): Observable<IncomingMailPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomingMailPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = IncomingMailPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MetadataFieldsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDocumentType(body: RequestCreateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/MetadataFields/CreateDocumentType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processCreateDocumentType(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocumentType(body: RequestUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/MetadataFields/UpdateDocumentType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateDocumentType(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fieldId (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMetaDataBydocumentType(fieldId: number | undefined, body: number | undefined): Observable<MetadataFieldDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/MetadataFields/getAllMetaDataBydocumentType?";
        if (fieldId === null)
            throw new Error("The parameter 'fieldId' cannot be null.");
        else if (fieldId !== undefined)
            url_ += "FieldId=" + encodeURIComponent("" + fieldId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMetaDataBydocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMetaDataBydocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetadataFieldDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetadataFieldDtoListServiceResponse>;
        }));
    }

    protected processGetAllMetaDataBydocumentType(response: HttpResponseBase): Observable<MetadataFieldDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetadataFieldDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MetadataFieldDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = MetadataFieldDtoListServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getById4(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MetadataFields/getById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update5(body: MetadataFieldUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/MetadataFields/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate5(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    delete5(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MetadataFields/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete5(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OutgoingMailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteOutgoing(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/OutgoingMail/deleteOutgoing/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOutgoing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutgoing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteOutgoing(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOutgoingMailById(id: number): Observable<OutgoingMailDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/OutgoingMail/GetOutgoingMailById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutgoingMailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutgoingMailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutgoingMailDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutgoingMailDtoServiceResponse>;
        }));
    }

    protected processGetOutgoingMailById(response: HttpResponseBase): Observable<OutgoingMailDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutgoingMailDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = OutgoingMailDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOutgoingMail(body: OutgoingMailWithAttachmentsCreate | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/OutgoingMail/CreateOutgoingMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOutgoingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOutgoingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processCreateOutgoingMail(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOutgoingMail(body: OutgoingMailWithAttachmentsUpdate | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/OutgoingMail/UpdateOutgoingMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOutgoingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOutgoingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateOutgoingMail(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedOutgoingMails(body: OutgoingMailPagedRequestDto | undefined): Observable<OutgoingMailPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/OutgoingMail/GetPagedOutgoingMails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedOutgoingMails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedOutgoingMails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutgoingMailPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutgoingMailPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedOutgoingMails(response: HttpResponseBase): Observable<OutgoingMailPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutgoingMailPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = OutgoingMailPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPermissions(body: number | undefined): Observable<PermissionsDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/Permissions/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionsDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionsDtoListServiceResponse>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionsDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionsDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = PermissionsDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPermission(body: PermissionsCreateDto | undefined): Observable<Int64NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Permissions/createPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int64NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int64NullableServiceResponse>;
        }));
    }

    protected processCreatePermission(response: HttpResponseBase): Observable<Int64NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int64NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int64NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPermissionById(id: number): Observable<PermissionsDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Permissions/GetPermissionById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionsDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionsDtoServiceResponse>;
        }));
    }

    protected processGetPermissionById(response: HttpResponseBase): Observable<PermissionsDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionsDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = PermissionsDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePermission(body: PermissionsUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Permissions/updatePermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdatePermission(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deletePermission(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Permissions/deletePermission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeletePermission(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RolesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRole(body: RoleCreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/createRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRoles(): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/GetAllRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllRoles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoleById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/GetRoleById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRoleById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRole(body: RoleUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/updateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/deleteRole/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SectorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllSectors(body: SectorFilterDto | undefined): Observable<SectorDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/Sectors/GetAllSectors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectorDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectorDtoListServiceResponse>;
        }));
    }

    protected processGetAllSectors(response: HttpResponseBase): Observable<SectorDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectorDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SectorDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedSectors(body: PagedRequestDto | undefined): Observable<SectorDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Sectors/GetPagedSectors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedSectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedSectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectorDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectorDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedSectors(response: HttpResponseBase): Observable<SectorDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectorDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SectorDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSectorById(id: number): Observable<SectorDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Sectors/GetSectorById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectorById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectorById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectorDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectorDtoServiceResponse>;
        }));
    }

    protected processGetSectorById(response: HttpResponseBase): Observable<SectorDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectorDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SectorDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSector(body: SectorCreateDto | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Sectors/CreateSector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateSector(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSector(body: SectorUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Sectors/UpdateSector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateSector(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteSector(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Sectors/DeleteSector/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteSector(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SenderEntitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllSenderEntities(body: SenderEntityFilterDto | undefined): Observable<SenderEntityDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/SenderEntities/GetAllSenderEntities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSenderEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSenderEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SenderEntityDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SenderEntityDtoListServiceResponse>;
        }));
    }

    protected processGetAllSenderEntities(response: HttpResponseBase): Observable<SenderEntityDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SenderEntityDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SenderEntityDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedSenderEntities(body: PagedRequestDto | undefined): Observable<SenderEntityDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/SenderEntities/GetPagedSenderEntities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedSenderEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedSenderEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SenderEntityDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SenderEntityDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedSenderEntities(response: HttpResponseBase): Observable<SenderEntityDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SenderEntityDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SenderEntityDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSenderEntityById(id: number): Observable<SenderEntityDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/SenderEntities/GetSenderEntityById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSenderEntityById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSenderEntityById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SenderEntityDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SenderEntityDtoServiceResponse>;
        }));
    }

    protected processGetSenderEntityById(response: HttpResponseBase): Observable<SenderEntityDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SenderEntityDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SenderEntityDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSenderEntity(body: SenderEntityCreateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/SenderEntities/CreateSenderEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSenderEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSenderEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processCreateSenderEntity(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSenderEntity(body: SenderEntityUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/SenderEntities/UpdateSenderEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSenderEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSenderEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateSenderEntity(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteSenderEntity(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/SenderEntities/DeleteSenderEntity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSenderEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSenderEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteSenderEntity(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TagsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTag(body: TagsCreateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Tags/createTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processCreateTag(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Int32NullableServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllTags(): Observable<TagsDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/Tags/GetAllTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagsDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagsDtoListServiceResponse>;
        }));
    }

    protected processGetAllTags(response: HttpResponseBase): Observable<TagsDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagsDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = TagsDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = TagsDtoListServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllTagsWithPaging(body: PagedRequestDto | undefined): Observable<TagsDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Tags/GetAllTagsWithPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTagsWithPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTagsWithPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagsDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagsDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetAllTagsWithPaging(response: HttpResponseBase): Observable<TagsDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagsDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = TagsDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = TagsDtoPagedResponseDtoServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTagById(id: number): Observable<TagsDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Tags/GetTagById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagsDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagsDtoServiceResponse>;
        }));
    }

    protected processGetTagById(response: HttpResponseBase): Observable<TagsDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagsDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = TagsDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = TagsDtoServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTag(body: TagsUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Tags/updateTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateTag(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Int32NullableServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteTag(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Tags/deleteTag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteTag(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = Int32NullableServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TransactionTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedTransactionTypes(body: PagedRequestDto | undefined): Observable<TransactionTypeDtoPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/TransactionTypes/GetPagedTransactionTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedTransactionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedTransactionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTypeDtoPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTypeDtoPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedTransactionTypes(response: HttpResponseBase): Observable<TransactionTypeDtoPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeDtoPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = TransactionTypeDtoPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllTransactionTypes(): Observable<TransactionTypeDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/TransactionTypes/GetAllTransactionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransactionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTypeDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTypeDtoListServiceResponse>;
        }));
    }

    protected processGetAllTransactionTypes(response: HttpResponseBase): Observable<TransactionTypeDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = TransactionTypeDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTransactionType(body: TransactionTypeCreateDto | undefined): Observable<DecimalNullableServiceResponse> {
        let url_ = this.baseUrl + "/api/TransactionTypes/CreateTransactionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransactionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransactionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DecimalNullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DecimalNullableServiceResponse>;
        }));
    }

    protected processCreateTransactionType(response: HttpResponseBase): Observable<DecimalNullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecimalNullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DecimalNullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTransactionTypeById(id: number): Observable<TransactionTypeDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/TransactionTypes/GetTransactionTypeById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTypeDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTypeDtoServiceResponse>;
        }));
    }

    protected processGetTransactionTypeById(response: HttpResponseBase): Observable<TransactionTypeDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionTypeDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = TransactionTypeDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransactionType(body: TransactionTypeUpdateDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/TransactionTypes/UpdateTransactionType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransactionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransactionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateTransactionType(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteTransactionType(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/TransactionTypes/DeleteTransactionType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTransactionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTransactionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteTransactionType(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagedUsers(body: PagedRequestDto | undefined): Observable<UserPagedResponseDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/GetPagedUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPagedResponseDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPagedResponseDtoServiceResponse>;
        }));
    }

    protected processGetPagedUsers(response: HttpResponseBase): Observable<UserPagedResponseDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPagedResponseDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserPagedResponseDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUser(id: string, body: UserSelectRequest | undefined): Observable<UserServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/GetUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserServiceResponse>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: UserCreateWithPermissionsDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/createUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UserUpdateWithPermissionsDto | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/updateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserToEdit(body: number | undefined): Observable<UserWithPermissionsDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/GetUserToEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserToEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserToEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWithPermissionsDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWithPermissionsDtoServiceResponse>;
        }));
    }

    protected processGetUserToEdit(response: HttpResponseBase): Observable<UserWithPermissionsDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWithPermissionsDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserWithPermissionsDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = UserWithPermissionsDtoServiceResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    allUsers(): Observable<UserListServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/AllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListServiceResponse>;
        }));
    }

    protected processAllUsers(response: HttpResponseBase): Observable<UserListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteUser(id: number): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/deleteUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserRole(body: UserRoleCreateDto | undefined): Observable<UserRoleResultServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/createUserRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleResultServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleResultServiceResponse>;
        }));
    }

    protected processCreateUserRole(response: HttpResponseBase): Observable<UserRoleResultServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleResultServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserRoleResultServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param roleId (optional) 
     * @return Success
     */
    deleteUserRole(userId: number | undefined, roleId: number | undefined): Observable<Int32NullableServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/deleteUserRole?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableServiceResponse>;
        }));
    }

    protected processDeleteUserRole(response: HttpResponseBase): Observable<Int32NullableServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = Int32NullableServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUserRoles(): Observable<UserRoleDtoListServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/GetAllUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDtoListServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDtoListServiceResponse>;
        }));
    }

    protected processGetAllUserRoles(response: HttpResponseBase): Observable<UserRoleDtoListServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDtoListServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserRoleDtoListServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getByUserRolesKey(userId: number, roleId: number): Observable<UserRoleDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/GetByUserRolesKey/{userId}/{roleId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserRolesKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserRolesKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDtoServiceResponse>;
        }));
    }

    protected processGetByUserRolesKey(response: HttpResponseBase): Observable<UserRoleDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserRoleDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserRole(body: UserRoleDto | undefined): Observable<UserRoleDtoServiceResponse> {
        let url_ = this.baseUrl + "/api/Users/updateUserRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDtoServiceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDtoServiceResponse>;
        }));
    }

    protected processUpdateUserRole(response: HttpResponseBase): Observable<UserRoleDtoServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDtoServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UserRoleDtoServiceResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkflowInstancesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWorkflowInstance(body: WorkflowInstanceCreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowInstances/createWorkflowInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkflowInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkflowInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWorkflowInstance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllWorkflowInstances(): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowInstances/GetAllWorkflowInstances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkflowInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkflowInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllWorkflowInstances(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWorkflowInstanceById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowInstances/GetWorkflowInstanceById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkflowInstanceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkflowInstanceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetWorkflowInstanceById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkflowInstance(body: WorkflowInstanceUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowInstances/updateWorkflowInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkflowInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkflowInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWorkflowInstance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteWorkflowInstance(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowInstances/deleteWorkflowInstance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkflowInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkflowInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWorkflowInstance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkflowsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWorkflow(body: WorkflowCreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflows/createWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWorkflow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllWorkflows(): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflows/GetAllWorkflows";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkflows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkflows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllWorkflows(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWorkflowById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflows/GetWorkflowById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkflowById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkflowById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetWorkflowById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkflow(body: WorkflowUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflows/updateWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWorkflow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteWorkflow(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflows/deleteWorkflow/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWorkflow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkflowStepsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWorkflowStep(body: WorkflowStepCreateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowSteps/createWorkflowStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkflowStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkflowStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWorkflowStep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllWorkflowSteps(): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowSteps/GetAllWorkflowSteps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkflowSteps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkflowSteps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllWorkflowSteps(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWorkflowStepById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowSteps/GetWorkflowStepById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkflowStepById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkflowStepById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetWorkflowStepById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkflowStep(body: WorkflowStepUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowSteps/updateWorkflowStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkflowStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkflowStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWorkflowStep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteWorkflowStep(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowSteps/deleteWorkflowStep/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkflowStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkflowStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWorkflowStep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActionTypeCreateDto implements IActionTypeCreateDto {
    name?: string | undefined;
    nameEn?: string | undefined;
    recordStatus?: number;

    constructor(data?: IActionTypeCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): ActionTypeCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IActionTypeCreateDto {
    name?: string | undefined;
    nameEn?: string | undefined;
    recordStatus?: number;
}

export class ActionTypeDto implements IActionTypeDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: IActionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): ActionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IActionTypeDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;
}

export class ActionTypeDtoListServiceResponse implements IActionTypeDtoListServiceResponse {
    result?: ActionTypeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IActionTypeDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ActionTypeDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ActionTypeDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IActionTypeDtoListServiceResponse {
    result?: ActionTypeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class ActionTypeDtoPagedResponseDto implements IActionTypeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: ActionTypeDto[] | undefined;
    totalItems?: number;

    constructor(data?: IActionTypeDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ActionTypeDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ActionTypeDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IActionTypeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: ActionTypeDto[] | undefined;
    totalItems?: number;
}

export class ActionTypeDtoPagedResponseDtoServiceResponse implements IActionTypeDtoPagedResponseDtoServiceResponse {
    result?: ActionTypeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IActionTypeDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ActionTypeDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ActionTypeDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IActionTypeDtoPagedResponseDtoServiceResponse {
    result?: ActionTypeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class ActionTypeDtoServiceResponse implements IActionTypeDtoServiceResponse {
    result?: ActionTypeDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IActionTypeDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ActionTypeDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ActionTypeDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IActionTypeDtoServiceResponse {
    result?: ActionTypeDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class ActionTypeUpdateDto implements IActionTypeUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: IActionTypeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): ActionTypeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IActionTypeUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
}

export class AttachmentDto implements IAttachmentDto {
    base64?: string | undefined;
    fileName?: string | undefined;
    fileSize?: number | undefined;
    fileType?: string | undefined;
    filePath?: string | undefined;
    extractedText?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.fileType = _data["fileType"];
            this.filePath = _data["filePath"];
            this.extractedText = _data["extractedText"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["fileType"] = this.fileType;
        data["filePath"] = this.filePath;
        data["extractedText"] = this.extractedText;
        return data;
    }
}

export interface IAttachmentDto {
    base64?: string | undefined;
    fileName?: string | undefined;
    fileSize?: number | undefined;
    fileType?: string | undefined;
    filePath?: string | undefined;
    extractedText?: string | undefined;
}

export class AuditLogCreateDto implements IAuditLogCreateDto {
    userId?: number | undefined;
    action?: string | undefined;
    entityType?: string | undefined;
    entityId?: number | undefined;
    timestamp?: Date | undefined;
    ip?: string | undefined;
    details?: string | undefined;
    recordStatus?: number;

    constructor(data?: IAuditLogCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.action = _data["action"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.ip = _data["ip"];
            this.details = _data["details"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): AuditLogCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["action"] = this.action;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["ip"] = this.ip;
        data["details"] = this.details;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IAuditLogCreateDto {
    userId?: number | undefined;
    action?: string | undefined;
    entityType?: string | undefined;
    entityId?: number | undefined;
    timestamp?: Date | undefined;
    ip?: string | undefined;
    details?: string | undefined;
    recordStatus?: number;
}

export class AuditLogUpdateDto implements IAuditLogUpdateDto {
    id?: number;
    userId?: number | undefined;
    action?: string | undefined;
    entityType?: string | undefined;
    entityId?: number | undefined;
    timestamp?: Date | undefined;
    ip?: string | undefined;
    details?: string | undefined;
    recordStatus?: number;

    constructor(data?: IAuditLogUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.action = _data["action"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.ip = _data["ip"];
            this.details = _data["details"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): AuditLogUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["action"] = this.action;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["ip"] = this.ip;
        data["details"] = this.details;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IAuditLogUpdateDto {
    id?: number;
    userId?: number | undefined;
    action?: string | undefined;
    entityType?: string | undefined;
    entityId?: number | undefined;
    timestamp?: Date | undefined;
    ip?: string | undefined;
    details?: string | undefined;
    recordStatus?: number;
}

export class DecimalNullableServiceResponse implements IDecimalNullableServiceResponse {
    result?: number | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDecimalNullableServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DecimalNullableServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalNullableServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDecimalNullableServiceResponse {
    result?: number | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class Department implements IDepartment {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDepartment {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class DepartmentCreateDto implements IDepartmentCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;

    constructor(data?: IDepartmentCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DepartmentCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IDepartmentCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
}

export class DepartmentDto implements IDepartmentDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDepartmentDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class DepartmentDtoListServiceResponse implements IDepartmentDtoListServiceResponse {
    result?: DepartmentDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDepartmentDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(DepartmentDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DepartmentDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDepartmentDtoListServiceResponse {
    result?: DepartmentDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DepartmentDtoServiceResponse implements IDepartmentDtoServiceResponse {
    result?: DepartmentDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDepartmentDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DepartmentDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DepartmentDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDepartmentDtoServiceResponse {
    result?: DepartmentDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DepartmentPagedResponseDto implements IDepartmentPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: Department[] | undefined;
    totalItems?: number;

    constructor(data?: IDepartmentPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Department.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): DepartmentPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IDepartmentPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: Department[] | undefined;
    totalItems?: number;
}

export class DepartmentPagedResponseDtoServiceResponse implements IDepartmentPagedResponseDtoServiceResponse {
    result?: DepartmentPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDepartmentPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DepartmentPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DepartmentPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDepartmentPagedResponseDtoServiceResponse {
    result?: DepartmentPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DepartmentUpdateDto implements IDepartmentUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: IDepartmentUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DepartmentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IDepartmentUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
}

export class DocumentCreateDto implements IDocumentCreateDto {
    documentMonth?: number | undefined;
    documentYear?: number | undefined;
    name?: string | undefined;
    nameEN?: string | undefined;
    folderId?: number;
    documentNumber?: string | undefined;
    documentTypeId?: number | undefined;
    contentType?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    recordStatus?: number;
    tagId?: number;

    constructor(data?: IDocumentCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMonth = _data["documentMonth"];
            this.documentYear = _data["documentYear"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.folderId = _data["folderId"];
            this.documentNumber = _data["documentNumber"];
            this.documentTypeId = _data["documentTypeId"];
            this.contentType = _data["contentType"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isArchived = _data["isArchived"];
            this.recordStatus = _data["recordStatus"];
            this.tagId = _data["tagId"];
        }
    }

    static fromJS(data: any): DocumentCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentMonth"] = this.documentMonth;
        data["documentYear"] = this.documentYear;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["folderId"] = this.folderId;
        data["documentNumber"] = this.documentNumber;
        data["documentTypeId"] = this.documentTypeId;
        data["contentType"] = this.contentType;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isArchived"] = this.isArchived;
        data["recordStatus"] = this.recordStatus;
        data["tagId"] = this.tagId;
        return data;
    }
}

export interface IDocumentCreateDto {
    documentMonth?: number | undefined;
    documentYear?: number | undefined;
    name?: string | undefined;
    nameEN?: string | undefined;
    folderId?: number;
    documentNumber?: string | undefined;
    documentTypeId?: number | undefined;
    contentType?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    recordStatus?: number;
    tagId?: number;
}

export class DocumentDetailsDto implements IDocumentDetailsDto {
    document?: DocumentDto;
    tag?: TagsDto;
    documentType?: DocumentTypeDto;
    department?: DepartmentDto;
    documentVersions?: DocumentVersionIMGBase64Dto[] | undefined;
    documentMetaData?: DocumentMetadataDetailsDto[] | undefined;

    constructor(data?: IDocumentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? DocumentDto.fromJS(_data["document"]) : <any>undefined;
            this.tag = _data["tag"] ? TagsDto.fromJS(_data["tag"]) : <any>undefined;
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            this.department = _data["department"] ? DepartmentDto.fromJS(_data["department"]) : <any>undefined;
            if (Array.isArray(_data["documentVersions"])) {
                this.documentVersions = [] as any;
                for (let item of _data["documentVersions"])
                    this.documentVersions!.push(DocumentVersionIMGBase64Dto.fromJS(item));
            }
            if (Array.isArray(_data["documentMetaData"])) {
                this.documentMetaData = [] as any;
                for (let item of _data["documentMetaData"])
                    this.documentMetaData!.push(DocumentMetadataDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        if (Array.isArray(this.documentVersions)) {
            data["documentVersions"] = [];
            for (let item of this.documentVersions)
                data["documentVersions"].push(item.toJSON());
        }
        if (Array.isArray(this.documentMetaData)) {
            data["documentMetaData"] = [];
            for (let item of this.documentMetaData)
                data["documentMetaData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentDetailsDto {
    document?: DocumentDto;
    tag?: TagsDto;
    documentType?: DocumentTypeDto;
    department?: DepartmentDto;
    documentVersions?: DocumentVersionIMGBase64Dto[] | undefined;
    documentMetaData?: DocumentMetadataDetailsDto[] | undefined;
}

export class DocumentDetailsDtoServiceResponse implements IDocumentDetailsDtoServiceResponse {
    result?: DocumentDetailsDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDocumentDetailsDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DocumentDetailsDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DocumentDetailsDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetailsDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDocumentDetailsDtoServiceResponse {
    result?: DocumentDetailsDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DocumentDto implements IDocumentDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    folderId?: number;
    documentNumber?: string | undefined;
    documentMonth?: number | undefined;
    documentYear?: number | undefined;
    documentTypeId?: number | undefined;
    contentType?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.folderId = _data["folderId"];
            this.documentNumber = _data["documentNumber"];
            this.documentMonth = _data["documentMonth"];
            this.documentYear = _data["documentYear"];
            this.documentTypeId = _data["documentTypeId"];
            this.contentType = _data["contentType"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isArchived = _data["isArchived"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["folderId"] = this.folderId;
        data["documentNumber"] = this.documentNumber;
        data["documentMonth"] = this.documentMonth;
        data["documentYear"] = this.documentYear;
        data["documentTypeId"] = this.documentTypeId;
        data["contentType"] = this.contentType;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isArchived"] = this.isArchived;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    folderId?: number;
    documentNumber?: string | undefined;
    documentMonth?: number | undefined;
    documentYear?: number | undefined;
    documentTypeId?: number | undefined;
    contentType?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class DocumentDtoFolderPageResponse implements IDocumentDtoFolderPageResponse {
    pageNumber?: number;
    pageSize?: number;
    folder?: Folder;
    subFolder?: Folder;
    data?: DocumentDto[] | undefined;
    totalItems?: number;

    constructor(data?: IDocumentDtoFolderPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.folder = _data["folder"] ? Folder.fromJS(_data["folder"]) : <any>undefined;
            this.subFolder = _data["subFolder"] ? Folder.fromJS(_data["subFolder"]) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): DocumentDtoFolderPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDtoFolderPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["folder"] = this.folder ? this.folder.toJSON() : <any>undefined;
        data["subFolder"] = this.subFolder ? this.subFolder.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IDocumentDtoFolderPageResponse {
    pageNumber?: number;
    pageSize?: number;
    folder?: Folder;
    subFolder?: Folder;
    data?: DocumentDto[] | undefined;
    totalItems?: number;
}

export class DocumentDtoFolderPageResponseServiceResponse implements IDocumentDtoFolderPageResponseServiceResponse {
    result?: DocumentDtoFolderPageResponse;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDocumentDtoFolderPageResponseServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DocumentDtoFolderPageResponse.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DocumentDtoFolderPageResponseServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDtoFolderPageResponseServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDocumentDtoFolderPageResponseServiceResponse {
    result?: DocumentDtoFolderPageResponse;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DocumentMetadataCreateDto implements IDocumentMetadataCreateDto {
    documentId?: number;
    fieldId?: number;
    value?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDocumentMetadataCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.fieldId = _data["fieldId"];
            this.value = _data["value"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentMetadataCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMetadataCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fieldId"] = this.fieldId;
        data["value"] = this.value;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentMetadataCreateDto {
    documentId?: number;
    fieldId?: number;
    value?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class DocumentMetadataDetailsDto implements IDocumentMetadataDetailsDto {
    fieldId?: number;
    fieldName?: string | undefined;
    fieldNameEN?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    optionsArray?: string | undefined;
    value?: string | undefined;

    constructor(data?: IDocumentMetadataDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.fieldName = _data["fieldName"];
            this.fieldNameEN = _data["fieldNameEN"];
            this.dataType = _data["dataType"];
            this.isRequired = _data["isRequired"];
            this.optionsArray = _data["optionsArray"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DocumentMetadataDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMetadataDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["fieldName"] = this.fieldName;
        data["fieldNameEN"] = this.fieldNameEN;
        data["dataType"] = this.dataType;
        data["isRequired"] = this.isRequired;
        data["optionsArray"] = this.optionsArray;
        data["value"] = this.value;
        return data;
    }
}

export interface IDocumentMetadataDetailsDto {
    fieldId?: number;
    fieldName?: string | undefined;
    fieldNameEN?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    optionsArray?: string | undefined;
    value?: string | undefined;
}

export class DocumentMetadataDto implements IDocumentMetadataDto {
    id?: number;
    documentId?: number;
    fieldId?: number;
    value?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDocumentMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.fieldId = _data["fieldId"];
            this.value = _data["value"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["fieldId"] = this.fieldId;
        data["value"] = this.value;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentMetadataDto {
    id?: number;
    documentId?: number;
    fieldId?: number;
    value?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class DocumentMetadataDtoListServiceResponse implements IDocumentMetadataDtoListServiceResponse {
    result?: DocumentMetadataDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDocumentMetadataDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(DocumentMetadataDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DocumentMetadataDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMetadataDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDocumentMetadataDtoListServiceResponse {
    result?: DocumentMetadataDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DocumentMetadataUpdateDto implements IDocumentMetadataUpdateDto {
    id?: number;
    documentId?: number;
    fieldId?: number;
    value?: string | undefined;
    recordStatus?: number;

    constructor(data?: IDocumentMetadataUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.fieldId = _data["fieldId"];
            this.value = _data["value"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DocumentMetadataUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMetadataUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["fieldId"] = this.fieldId;
        data["value"] = this.value;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IDocumentMetadataUpdateDto {
    id?: number;
    documentId?: number;
    fieldId?: number;
    value?: string | undefined;
    recordStatus?: number;
}

export class DocumentTagCreateDto implements IDocumentTagCreateDto {
    documentId?: number;
    tagId?: number;
    recordStatus?: number;

    constructor(data?: IDocumentTagCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.tagId = _data["tagId"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DocumentTagCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTagCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["tagId"] = this.tagId;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IDocumentTagCreateDto {
    documentId?: number;
    tagId?: number;
    recordStatus?: number;
}

export class DocumentTagUpdateDto implements IDocumentTagUpdateDto {
    documentId?: number;
    tagId?: number;
    recordStatus?: number;

    constructor(data?: IDocumentTagUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.tagId = _data["tagId"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DocumentTagUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTagUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["tagId"] = this.tagId;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IDocumentTagUpdateDto {
    documentId?: number;
    tagId?: number;
    recordStatus?: number;
}

export class DocumentTypeCreateDto implements IDocumentTypeCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDocumentTypeCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTypeCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentTypeCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class DocumentTypeDto implements IDocumentTypeDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentTypeDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class DocumentTypeDtoListServiceResponse implements IDocumentTypeDtoListServiceResponse {
    result?: DocumentTypeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDocumentTypeDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(DocumentTypeDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DocumentTypeDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDocumentTypeDtoListServiceResponse {
    result?: DocumentTypeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DocumentTypeDtoPagedResponseDto implements IDocumentTypeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: DocumentTypeDto[] | undefined;
    totalItems?: number;

    constructor(data?: IDocumentTypeDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentTypeDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): DocumentTypeDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IDocumentTypeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: DocumentTypeDto[] | undefined;
    totalItems?: number;
}

export class DocumentTypeDtoPagedResponseDtoServiceResponse implements IDocumentTypeDtoPagedResponseDtoServiceResponse {
    result?: DocumentTypeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDocumentTypeDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DocumentTypeDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DocumentTypeDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDocumentTypeDtoPagedResponseDtoServiceResponse {
    result?: DocumentTypeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DocumentTypeUpdateDto implements IDocumentTypeUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;

    constructor(data?: IDocumentTypeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DocumentTypeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IDocumentTypeUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
}

export class DocumentUpdate implements IDocumentUpdate {
    documentUpdateDto?: DocumentUpdateDto;
    documentVersionCreate?: DocumentVersionCreateDto[] | undefined;
    documentMetadataCreate?: DocumentMetadataCreateDto[] | undefined;

    constructor(data?: IDocumentUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentUpdateDto = _data["documentUpdateDto"] ? DocumentUpdateDto.fromJS(_data["documentUpdateDto"]) : <any>undefined;
            if (Array.isArray(_data["documentVersionCreate"])) {
                this.documentVersionCreate = [] as any;
                for (let item of _data["documentVersionCreate"])
                    this.documentVersionCreate!.push(DocumentVersionCreateDto.fromJS(item));
            }
            if (Array.isArray(_data["documentMetadataCreate"])) {
                this.documentMetadataCreate = [] as any;
                for (let item of _data["documentMetadataCreate"])
                    this.documentMetadataCreate!.push(DocumentMetadataCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentUpdateDto"] = this.documentUpdateDto ? this.documentUpdateDto.toJSON() : <any>undefined;
        if (Array.isArray(this.documentVersionCreate)) {
            data["documentVersionCreate"] = [];
            for (let item of this.documentVersionCreate)
                data["documentVersionCreate"].push(item.toJSON());
        }
        if (Array.isArray(this.documentMetadataCreate)) {
            data["documentMetadataCreate"] = [];
            for (let item of this.documentMetadataCreate)
                data["documentMetadataCreate"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentUpdate {
    documentUpdateDto?: DocumentUpdateDto;
    documentVersionCreate?: DocumentVersionCreateDto[] | undefined;
    documentMetadataCreate?: DocumentMetadataCreateDto[] | undefined;
}

export class DocumentUpdateDto implements IDocumentUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    folderId?: number;
    documentNumber?: string | undefined;
    documentTypeId?: number | undefined;
    contentType?: string | undefined;
    documentMonth?: number | undefined;
    documentYear?: number | undefined;
    updatedAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    recordStatus?: number;
    tagId?: number;

    constructor(data?: IDocumentUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.folderId = _data["folderId"];
            this.documentNumber = _data["documentNumber"];
            this.documentTypeId = _data["documentTypeId"];
            this.contentType = _data["contentType"];
            this.documentMonth = _data["documentMonth"];
            this.documentYear = _data["documentYear"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isArchived = _data["isArchived"];
            this.recordStatus = _data["recordStatus"];
            this.tagId = _data["tagId"];
        }
    }

    static fromJS(data: any): DocumentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["folderId"] = this.folderId;
        data["documentNumber"] = this.documentNumber;
        data["documentTypeId"] = this.documentTypeId;
        data["contentType"] = this.contentType;
        data["documentMonth"] = this.documentMonth;
        data["documentYear"] = this.documentYear;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isArchived"] = this.isArchived;
        data["recordStatus"] = this.recordStatus;
        data["tagId"] = this.tagId;
        return data;
    }
}

export interface IDocumentUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    folderId?: number;
    documentNumber?: string | undefined;
    documentTypeId?: number | undefined;
    contentType?: string | undefined;
    documentMonth?: number | undefined;
    documentYear?: number | undefined;
    updatedAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    recordStatus?: number;
    tagId?: number;
}

export class DocumentVersionCreateDto implements IDocumentVersionCreateDto {
    fileCategoryId?: number | undefined;
    versionNumber?: number;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    size?: number | undefined;
    uploadedBy?: number | undefined;
    uploadedAt?: Date | undefined;
    ocrText?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    fileName?: string | undefined;
    base64?: string | undefined;

    constructor(data?: IDocumentVersionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileCategoryId = _data["fileCategoryId"];
            this.versionNumber = _data["versionNumber"];
            this.filePath = _data["filePath"];
            this.fileHash = _data["fileHash"];
            this.size = _data["size"];
            this.uploadedBy = _data["uploadedBy"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : <any>undefined;
            this.ocrText = _data["ocrText"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): DocumentVersionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileCategoryId"] = this.fileCategoryId;
        data["versionNumber"] = this.versionNumber;
        data["filePath"] = this.filePath;
        data["fileHash"] = this.fileHash;
        data["size"] = this.size;
        data["uploadedBy"] = this.uploadedBy;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : <any>undefined;
        data["ocrText"] = this.ocrText;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["base64"] = this.base64;
        return data;
    }
}

export interface IDocumentVersionCreateDto {
    fileCategoryId?: number | undefined;
    versionNumber?: number;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    size?: number | undefined;
    uploadedBy?: number | undefined;
    uploadedAt?: Date | undefined;
    ocrText?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    fileName?: string | undefined;
    base64?: string | undefined;
}

export class DocumentVersionDetailsDto implements IDocumentVersionDetailsDto {
    sharedLink?: SharedLinkDto;
    documentVersion?: DocumentVersionIMGBase64Dto;

    constructor(data?: IDocumentVersionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedLink = _data["sharedLink"] ? SharedLinkDto.fromJS(_data["sharedLink"]) : <any>undefined;
            this.documentVersion = _data["documentVersion"] ? DocumentVersionIMGBase64Dto.fromJS(_data["documentVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentVersionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedLink"] = this.sharedLink ? this.sharedLink.toJSON() : <any>undefined;
        data["documentVersion"] = this.documentVersion ? this.documentVersion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentVersionDetailsDto {
    sharedLink?: SharedLinkDto;
    documentVersion?: DocumentVersionIMGBase64Dto;
}

export class DocumentVersionDetailsDtoServiceResponse implements IDocumentVersionDetailsDtoServiceResponse {
    result?: DocumentVersionDetailsDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IDocumentVersionDetailsDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DocumentVersionDetailsDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DocumentVersionDetailsDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionDetailsDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IDocumentVersionDetailsDtoServiceResponse {
    result?: DocumentVersionDetailsDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class DocumentVersionIMGBase64Dto implements IDocumentVersionIMGBase64Dto {
    fileBase64?: string | undefined;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    size?: number | undefined;
    documentVersionId?: number;
    extractedText?: string | undefined;
    categoryId?: number;
    categoryName?: string | undefined;
    categoryNameEn?: string | undefined;

    constructor(data?: IDocumentVersionIMGBase64Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileBase64 = _data["fileBase64"];
            this.filePath = _data["filePath"];
            this.fileHash = _data["fileHash"];
            this.size = _data["size"];
            this.documentVersionId = _data["documentVersionId"];
            this.extractedText = _data["extractedText"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.categoryNameEn = _data["categoryNameEn"];
        }
    }

    static fromJS(data: any): DocumentVersionIMGBase64Dto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionIMGBase64Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileBase64"] = this.fileBase64;
        data["filePath"] = this.filePath;
        data["fileHash"] = this.fileHash;
        data["size"] = this.size;
        data["documentVersionId"] = this.documentVersionId;
        data["extractedText"] = this.extractedText;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["categoryNameEn"] = this.categoryNameEn;
        return data;
    }
}

export interface IDocumentVersionIMGBase64Dto {
    fileBase64?: string | undefined;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    size?: number | undefined;
    documentVersionId?: number;
    extractedText?: string | undefined;
    categoryId?: number;
    categoryName?: string | undefined;
    categoryNameEn?: string | undefined;
}

export class DocumentVersionUpdateDto implements IDocumentVersionUpdateDto {
    id?: number;
    documentId?: number;
    versionNumber?: number;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    size?: number | undefined;
    uploadedBy?: number | undefined;
    uploadedAt?: Date | undefined;
    ocrText?: string | undefined;
    recordStatus?: number;

    constructor(data?: IDocumentVersionUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.versionNumber = _data["versionNumber"];
            this.filePath = _data["filePath"];
            this.fileHash = _data["fileHash"];
            this.size = _data["size"];
            this.uploadedBy = _data["uploadedBy"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : <any>undefined;
            this.ocrText = _data["ocrText"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DocumentVersionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["versionNumber"] = this.versionNumber;
        data["filePath"] = this.filePath;
        data["fileHash"] = this.fileHash;
        data["size"] = this.size;
        data["uploadedBy"] = this.uploadedBy;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : <any>undefined;
        data["ocrText"] = this.ocrText;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IDocumentVersionUpdateDto {
    id?: number;
    documentId?: number;
    versionNumber?: number;
    filePath?: string | undefined;
    fileHash?: string | undefined;
    size?: number | undefined;
    uploadedBy?: number | undefined;
    uploadedAt?: Date | undefined;
    ocrText?: string | undefined;
    recordStatus?: number;
}

export class DocumwntWithDocumentVersionCreate implements IDocumwntWithDocumentVersionCreate {
    documentCreate?: DocumentCreateDto;
    documentVersionCreate?: DocumentVersionCreateDto[] | undefined;
    documentMetadataCreate?: DocumentMetadataCreateDto[] | undefined;

    constructor(data?: IDocumwntWithDocumentVersionCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentCreate = _data["documentCreate"] ? DocumentCreateDto.fromJS(_data["documentCreate"]) : <any>undefined;
            if (Array.isArray(_data["documentVersionCreate"])) {
                this.documentVersionCreate = [] as any;
                for (let item of _data["documentVersionCreate"])
                    this.documentVersionCreate!.push(DocumentVersionCreateDto.fromJS(item));
            }
            if (Array.isArray(_data["documentMetadataCreate"])) {
                this.documentMetadataCreate = [] as any;
                for (let item of _data["documentMetadataCreate"])
                    this.documentMetadataCreate!.push(DocumentMetadataCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumwntWithDocumentVersionCreate {
        data = typeof data === 'object' ? data : {};
        let result = new DocumwntWithDocumentVersionCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentCreate"] = this.documentCreate ? this.documentCreate.toJSON() : <any>undefined;
        if (Array.isArray(this.documentVersionCreate)) {
            data["documentVersionCreate"] = [];
            for (let item of this.documentVersionCreate)
                data["documentVersionCreate"].push(item.toJSON());
        }
        if (Array.isArray(this.documentMetadataCreate)) {
            data["documentMetadataCreate"] = [];
            for (let item of this.documentMetadataCreate)
                data["documentMetadataCreate"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumwntWithDocumentVersionCreate {
    documentCreate?: DocumentCreateDto;
    documentVersionCreate?: DocumentVersionCreateDto[] | undefined;
    documentMetadataCreate?: DocumentMetadataCreateDto[] | undefined;
}

export class EmployeeCreateDto implements IEmployeeCreateDto {
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean;
    recordStatus?: number;

    constructor(data?: IEmployeeCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullNameAr = _data["fullNameAr"];
            this.fullNameEn = _data["fullNameEn"];
            this.departmentId = _data["departmentId"];
            this.isActive = _data["isActive"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): EmployeeCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullNameAr"] = this.fullNameAr;
        data["fullNameEn"] = this.fullNameEn;
        data["departmentId"] = this.departmentId;
        data["isActive"] = this.isActive;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IEmployeeCreateDto {
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean;
    recordStatus?: number;
}

export class EmployeeDto implements IEmployeeDto {
    id?: number;
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentNameAr?: string | undefined;
    departmentNameEn?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean;
    createdAt?: Date | undefined;
    recordStatus?: number | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullNameAr = _data["fullNameAr"];
            this.fullNameEn = _data["fullNameEn"];
            this.departmentNameAr = _data["departmentNameAr"];
            this.departmentNameEn = _data["departmentNameEn"];
            this.departmentId = _data["departmentId"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullNameAr"] = this.fullNameAr;
        data["fullNameEn"] = this.fullNameEn;
        data["departmentNameAr"] = this.departmentNameAr;
        data["departmentNameEn"] = this.departmentNameEn;
        data["departmentId"] = this.departmentId;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployeeDto {
    id?: number;
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentNameAr?: string | undefined;
    departmentNameEn?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean;
    createdAt?: Date | undefined;
    recordStatus?: number | undefined;
    deletedAt?: Date | undefined;
}

export class EmployeeDtoListServiceResponse implements IEmployeeDtoListServiceResponse {
    result?: EmployeeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IEmployeeDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(EmployeeDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): EmployeeDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IEmployeeDtoListServiceResponse {
    result?: EmployeeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class EmployeeDtoPagedResponseDto implements IEmployeeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: EmployeeDto[] | undefined;
    totalItems?: number;

    constructor(data?: IEmployeeDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EmployeeDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EmployeeDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEmployeeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: EmployeeDto[] | undefined;
    totalItems?: number;
}

export class EmployeeDtoPagedResponseDtoServiceResponse implements IEmployeeDtoPagedResponseDtoServiceResponse {
    result?: EmployeeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IEmployeeDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? EmployeeDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): EmployeeDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IEmployeeDtoPagedResponseDtoServiceResponse {
    result?: EmployeeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class EmployeeFilterDto implements IEmployeeFilterDto {
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentId?: number | undefined;
    employeeId?: number | undefined;

    constructor(data?: IEmployeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullNameAr = _data["fullNameAr"];
            this.fullNameEn = _data["fullNameEn"];
            this.departmentId = _data["departmentId"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullNameAr"] = this.fullNameAr;
        data["fullNameEn"] = this.fullNameEn;
        data["departmentId"] = this.departmentId;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeFilterDto {
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentId?: number | undefined;
    employeeId?: number | undefined;
}

export class EmployeeUpdateDto implements IEmployeeUpdateDto {
    id?: number;
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean;

    constructor(data?: IEmployeeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullNameAr = _data["fullNameAr"];
            this.fullNameEn = _data["fullNameEn"];
            this.departmentId = _data["departmentId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmployeeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullNameAr"] = this.fullNameAr;
        data["fullNameEn"] = this.fullNameEn;
        data["departmentId"] = this.departmentId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEmployeeUpdateDto {
    id?: number;
    fullNameAr?: string | undefined;
    fullNameEn?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean;
}

export class FileCategoryCreateDto implements IFileCategoryCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
    parentCategoryId?: number | undefined;

    constructor(data?: IFileCategoryCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.recordStatus = _data["recordStatus"];
            this.parentCategoryId = _data["parentCategoryId"];
        }
    }

    static fromJS(data: any): FileCategoryCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileCategoryCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["recordStatus"] = this.recordStatus;
        data["parentCategoryId"] = this.parentCategoryId;
        return data;
    }
}

export interface IFileCategoryCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    recordStatus?: number;
    parentCategoryId?: number | undefined;
}

export class FileCategoryDto implements IFileCategoryDto {
    id?: number;
    parentCategoryId?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: IFileCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentCategoryId = _data["parentCategoryId"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): FileCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentCategoryId"] = this.parentCategoryId;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IFileCategoryDto {
    id?: number;
    parentCategoryId?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;
}

export class FileCategoryDtoListServiceResponse implements IFileCategoryDtoListServiceResponse {
    result?: FileCategoryDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IFileCategoryDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(FileCategoryDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): FileCategoryDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileCategoryDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IFileCategoryDtoListServiceResponse {
    result?: FileCategoryDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class FileCategoryDtoPagedResponseDto implements IFileCategoryDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: FileCategoryDto[] | undefined;
    totalItems?: number;

    constructor(data?: IFileCategoryDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileCategoryDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): FileCategoryDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileCategoryDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IFileCategoryDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: FileCategoryDto[] | undefined;
    totalItems?: number;
}

export class FileCategoryDtoPagedResponseDtoServiceResponse implements IFileCategoryDtoPagedResponseDtoServiceResponse {
    result?: FileCategoryDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IFileCategoryDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? FileCategoryDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): FileCategoryDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileCategoryDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IFileCategoryDtoPagedResponseDtoServiceResponse {
    result?: FileCategoryDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class FileCategoryDtoServiceResponse implements IFileCategoryDtoServiceResponse {
    result?: FileCategoryDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IFileCategoryDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? FileCategoryDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): FileCategoryDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileCategoryDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IFileCategoryDtoServiceResponse {
    result?: FileCategoryDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class FileCategoryUpdateDto implements IFileCategoryUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: IFileCategoryUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): FileCategoryUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileCategoryUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IFileCategoryUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
}

export class Folder implements IFolder {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    parentId?: number | undefined;
    departmentId?: number | undefined;
    path?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.parentId = _data["parentId"];
            this.departmentId = _data["departmentId"];
            this.path = _data["path"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Folder {
        data = typeof data === 'object' ? data : {};
        let result = new Folder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["parentId"] = this.parentId;
        data["departmentId"] = this.departmentId;
        data["path"] = this.path;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFolder {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    parentId?: number | undefined;
    departmentId?: number | undefined;
    path?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class FolderCreateDto implements IFolderCreateDto {
    name?: string | undefined;
    nameEn?: string | undefined;
    parentId?: number | undefined;
    path?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    recordStatus?: number;
    departmentId?: number;

    constructor(data?: IFolderCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.parentId = _data["parentId"];
            this.path = _data["path"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.recordStatus = _data["recordStatus"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): FolderCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["parentId"] = this.parentId;
        data["path"] = this.path;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["recordStatus"] = this.recordStatus;
        data["departmentId"] = this.departmentId;
        return data;
    }
}

export interface IFolderCreateDto {
    name?: string | undefined;
    nameEn?: string | undefined;
    parentId?: number | undefined;
    path?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    isDeleted?: boolean | undefined;
    recordStatus?: number;
    departmentId?: number;
}

export class FolderPageResponse implements IFolderPageResponse {
    pageNumber?: number;
    pageSize?: number;
    parent?: Folder;
    data?: Folder[] | undefined;
    totalItems?: number;

    constructor(data?: IFolderPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.parent = _data["parent"] ? Folder.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Folder.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): FolderPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FolderPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IFolderPageResponse {
    pageNumber?: number;
    pageSize?: number;
    parent?: Folder;
    data?: Folder[] | undefined;
    totalItems?: number;
}

export class FolderPageResponseServiceResponse implements IFolderPageResponseServiceResponse {
    result?: FolderPageResponse;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IFolderPageResponseServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? FolderPageResponse.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): FolderPageResponseServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FolderPageResponseServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IFolderPageResponseServiceResponse {
    result?: FolderPageResponse;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class FolderPagedRequestDto implements IFolderPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    parentId?: number | undefined;
    documentName?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    year?: number | undefined;
    month?: number | undefined;
    tagId?: number | undefined;
    documentTypeId?: number | undefined;
    departmentId?: number | undefined;
    metadataFilter?: MetadataFilterDto[] | undefined;
    ocrSearchText?: string | undefined;

    constructor(data?: IFolderPagedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.parentId = _data["parentId"];
            this.documentName = _data["documentName"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.year = _data["year"];
            this.month = _data["month"];
            this.tagId = _data["tagId"];
            this.documentTypeId = _data["documentTypeId"];
            this.departmentId = _data["departmentId"];
            this.ocrSearchText= _data["ocrSearchText"];
            if (Array.isArray(_data["metadataFilter"])) {
                this.metadataFilter = [] as any;
                for (let item of _data["metadataFilter"])
                    this.metadataFilter!.push(MetadataFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FolderPagedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderPagedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["parentId"] = this.parentId;
        data["documentName"] = this.documentName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["year"] = this.year;
        data["month"] = this.month;
        data["tagId"] = this.tagId;
        data["documentTypeId"] = this.documentTypeId;
        data["departmentId"] = this.departmentId;
        data["ocrSearchText"] = this.ocrSearchText;
        if (Array.isArray(this.metadataFilter)) {
            data["metadataFilter"] = [];
            for (let item of this.metadataFilter)
                data["metadataFilter"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFolderPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    parentId?: number | undefined;
    documentName?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    year?: number | undefined;
    month?: number | undefined;
    tagId?: number | undefined;
    documentTypeId?: number | undefined;
    departmentId?: number | undefined;
    ocrSearchText?: string | undefined;
    metadataFilter?: MetadataFilterDto[] | undefined;
}

export class IncomingMail implements IIncomingMail {
    id?: number;
    incomingNumber?: string | undefined;
    incomingDate?: Date;
    receivingTime?: TimeSpan;
    senderLetterNumber?: string | undefined;
    senderLetterDate?: Date;
    secrecyLevel?: number;
    priority?: number;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    receiptNumber?: string | undefined;
    routingNotes?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isDraft?: boolean | undefined;
    recordStatus?: number;
    senderEntityId?: number | undefined;
    transactionTypeId?: number | undefined;
    sectorId?: number | undefined;
    receiverId?: number | undefined;
    currentDepartmentId?: number | undefined;
    responsibleEmployeeId?: number | undefined;
    receiptMethod?: number;
    accessLevel?: number;
    documentId?: number;

    constructor(data?: IIncomingMail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incomingNumber = _data["incomingNumber"];
            this.incomingDate = _data["incomingDate"] ? new Date(_data["incomingDate"].toString()) : <any>undefined;
            this.receivingTime = _data["receivingTime"] ? TimeSpan.fromJS(_data["receivingTime"]) : <any>undefined;
            this.senderLetterNumber = _data["senderLetterNumber"];
            this.senderLetterDate = _data["senderLetterDate"] ? new Date(_data["senderLetterDate"].toString()) : <any>undefined;
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.relatedReference = _data["relatedReference"];
            this.linkedOutgoing = _data["linkedOutgoing"];
            this.receiptNumber = _data["receiptNumber"];
            this.routingNotes = _data["routingNotes"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
            this.recordStatus = _data["recordStatus"];
            this.senderEntityId = _data["senderEntityId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.sectorId = _data["sectorId"];
            this.receiverId = _data["receiverId"];
            this.currentDepartmentId = _data["currentDepartmentId"];
            this.responsibleEmployeeId = _data["responsibleEmployeeId"];
            this.receiptMethod = _data["receiptMethod"];
            this.accessLevel = _data["accessLevel"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): IncomingMail {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incomingNumber"] = this.incomingNumber;
        data["incomingDate"] = this.incomingDate ? this.incomingDate.toISOString() : <any>undefined;
        data["receivingTime"] = this.receivingTime ? this.receivingTime.toJSON() : <any>undefined;
        data["senderLetterNumber"] = this.senderLetterNumber;
        data["senderLetterDate"] = this.senderLetterDate ? this.senderLetterDate.toISOString() : <any>undefined;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["relatedReference"] = this.relatedReference;
        data["linkedOutgoing"] = this.linkedOutgoing;
        data["receiptNumber"] = this.receiptNumber;
        data["routingNotes"] = this.routingNotes;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        data["recordStatus"] = this.recordStatus;
        data["senderEntityId"] = this.senderEntityId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["sectorId"] = this.sectorId;
        data["receiverId"] = this.receiverId;
        data["currentDepartmentId"] = this.currentDepartmentId;
        data["responsibleEmployeeId"] = this.responsibleEmployeeId;
        data["receiptMethod"] = this.receiptMethod;
        data["accessLevel"] = this.accessLevel;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IIncomingMail {
    id?: number;
    incomingNumber?: string | undefined;
    incomingDate?: Date;
    receivingTime?: TimeSpan;
    senderLetterNumber?: string | undefined;
    senderLetterDate?: Date;
    secrecyLevel?: number;
    priority?: number;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    receiptNumber?: string | undefined;
    routingNotes?: string | undefined;
    createdBy?: number;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    isDraft?: boolean | undefined;
    recordStatus?: number;
    senderEntityId?: number | undefined;
    transactionTypeId?: number | undefined;
    sectorId?: number | undefined;
    receiverId?: number | undefined;
    currentDepartmentId?: number | undefined;
    responsibleEmployeeId?: number | undefined;
    receiptMethod?: number;
    accessLevel?: number;
    documentId?: number;
}

export class IncomingMailCreateDto implements IIncomingMailCreateDto {
    incomingDate?: Date;
    receivingTime?: string | undefined;
    senderEntityId?: number;
    senderLetterNumber?: string | undefined;
    senderLetterDate?: Date;
    transactionTypeId?: number;
    secrecyLevel?: number;
    priority?: number;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    receiptMethod?: number;
    receiverId?: number;
    receiptNumber?: string | undefined;
    currentDepartmentId?: number;
    responsibleEmployeeId?: number | undefined;
    accessLevel?: number | undefined;
    routingNotes?: string | undefined;
    createdBy?: number;

    constructor(data?: IIncomingMailCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingDate = _data["incomingDate"] ? new Date(_data["incomingDate"].toString()) : <any>undefined;
            this.receivingTime = _data["receivingTime"];
            this.senderEntityId = _data["senderEntityId"];
            this.senderLetterNumber = _data["senderLetterNumber"];
            this.senderLetterDate = _data["senderLetterDate"] ? new Date(_data["senderLetterDate"].toString()) : <any>undefined;
            this.transactionTypeId = _data["transactionTypeId"];
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.sectorId = _data["sectorId"];
            this.relatedReference = _data["relatedReference"];
            this.linkedOutgoing = _data["linkedOutgoing"];
            this.receiptMethod = _data["receiptMethod"];
            this.receiverId = _data["receiverId"];
            this.receiptNumber = _data["receiptNumber"];
            this.currentDepartmentId = _data["currentDepartmentId"];
            this.responsibleEmployeeId = _data["responsibleEmployeeId"];
            this.accessLevel = _data["accessLevel"];
            this.routingNotes = _data["routingNotes"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): IncomingMailCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomingDate"] = this.incomingDate ? this.incomingDate.toISOString() : <any>undefined;
        data["receivingTime"] = this.receivingTime;
        data["senderEntityId"] = this.senderEntityId;
        data["senderLetterNumber"] = this.senderLetterNumber;
        data["senderLetterDate"] = this.senderLetterDate ? this.senderLetterDate.toISOString() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["sectorId"] = this.sectorId;
        data["relatedReference"] = this.relatedReference;
        data["linkedOutgoing"] = this.linkedOutgoing;
        data["receiptMethod"] = this.receiptMethod;
        data["receiverId"] = this.receiverId;
        data["receiptNumber"] = this.receiptNumber;
        data["currentDepartmentId"] = this.currentDepartmentId;
        data["responsibleEmployeeId"] = this.responsibleEmployeeId;
        data["accessLevel"] = this.accessLevel;
        data["routingNotes"] = this.routingNotes;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IIncomingMailCreateDto {
    incomingDate?: Date;
    receivingTime?: string | undefined;
    senderEntityId?: number;
    senderLetterNumber?: string | undefined;
    senderLetterDate?: Date;
    transactionTypeId?: number;
    secrecyLevel?: number;
    priority?: number;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    receiptMethod?: number;
    receiverId?: number;
    receiptNumber?: string | undefined;
    currentDepartmentId?: number;
    responsibleEmployeeId?: number | undefined;
    accessLevel?: number | undefined;
    routingNotes?: string | undefined;
    createdBy?: number;
}

export class IncomingMailDto implements IIncomingMailDto {
    id?: number;
    incomingNumber?: string | undefined;
    incomingDate?: Date | undefined;
    receivingTime?: string | undefined;
    senderLetterNumber?: string | undefined;
    receiptNumber?: string | undefined;
    folderId?: number;
    routingNotes?: string | undefined;
    senderLetterDate?: Date | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    senderEntityId?: number | undefined;
    senderEntityNameAr?: string | undefined;
    senderEntityNameEn?: string | undefined;
    transactionTypeNameAr?: string | undefined;
    transactionTypeNameEn?: string | undefined;
    transactionTypeId?: number | undefined;
    sectorId?: number | undefined;
    sectorNameAr?: string | undefined;
    sectorNameEn?: string | undefined;
    currentDepartmentId?: number | undefined;
    currentDepartmentNameAr?: string | undefined;
    currentDepartmentNameEn?: string | undefined;
    receiverId?: number | undefined;
    receiverNameAr?: string | undefined;
    receiverNameEn?: string | undefined;
    responsibleEmployeeId?: number | undefined;
    responsibleEmployeeNameAr?: string | undefined;
    responsibleEmployeeNameEn?: string | undefined;
    documentId?: number | undefined;
    documentNameAr?: string | undefined;
    documentNameEn?: string | undefined;
    secrecyLevel?: number | undefined;
    priority?: number | undefined;
    receiptMethod?: number | undefined;
    accessLevel?: number | undefined;
    keywords?: IncomingMailKeywordDto[] | undefined;
    documentVersions?: DocumentVersionIMGBase64Dto[] | undefined;

    constructor(data?: IIncomingMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incomingNumber = _data["incomingNumber"];
            this.incomingDate = _data["incomingDate"] ? new Date(_data["incomingDate"].toString()) : <any>undefined;
            this.receivingTime = _data["receivingTime"];
            this.senderLetterNumber = _data["senderLetterNumber"];
            this.receiptNumber = _data["receiptNumber"];
            this.folderId = _data["folderId"];
            this.routingNotes = _data["routingNotes"];
            this.senderLetterDate = _data["senderLetterDate"] ? new Date(_data["senderLetterDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.relatedReference = _data["relatedReference"];
            this.linkedOutgoing = _data["linkedOutgoing"];
            this.senderEntityId = _data["senderEntityId"];
            this.senderEntityNameAr = _data["senderEntityNameAr"];
            this.senderEntityNameEn = _data["senderEntityNameEn"];
            this.transactionTypeNameAr = _data["transactionTypeNameAr"];
            this.transactionTypeNameEn = _data["transactionTypeNameEn"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.sectorId = _data["sectorId"];
            this.sectorNameAr = _data["sectorNameAr"];
            this.sectorNameEn = _data["sectorNameEn"];
            this.currentDepartmentId = _data["currentDepartmentId"];
            this.currentDepartmentNameAr = _data["currentDepartmentNameAr"];
            this.currentDepartmentNameEn = _data["currentDepartmentNameEn"];
            this.receiverId = _data["receiverId"];
            this.receiverNameAr = _data["receiverNameAr"];
            this.receiverNameEn = _data["receiverNameEn"];
            this.responsibleEmployeeId = _data["responsibleEmployeeId"];
            this.responsibleEmployeeNameAr = _data["responsibleEmployeeNameAr"];
            this.responsibleEmployeeNameEn = _data["responsibleEmployeeNameEn"];
            this.documentId = _data["documentId"];
            this.documentNameAr = _data["documentNameAr"];
            this.documentNameEn = _data["documentNameEn"];
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.receiptMethod = _data["receiptMethod"];
            this.accessLevel = _data["accessLevel"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(IncomingMailKeywordDto.fromJS(item));
            }
            if (Array.isArray(_data["documentVersions"])) {
                this.documentVersions = [] as any;
                for (let item of _data["documentVersions"])
                    this.documentVersions!.push(DocumentVersionIMGBase64Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomingMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incomingNumber"] = this.incomingNumber;
        data["incomingDate"] = this.incomingDate ? this.incomingDate.toISOString() : <any>undefined;
        data["receivingTime"] = this.receivingTime;
        data["senderLetterNumber"] = this.senderLetterNumber;
        data["receiptNumber"] = this.receiptNumber;
        data["folderId"] = this.folderId;
        data["routingNotes"] = this.routingNotes;
        data["senderLetterDate"] = this.senderLetterDate ? this.senderLetterDate.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["relatedReference"] = this.relatedReference;
        data["linkedOutgoing"] = this.linkedOutgoing;
        data["senderEntityId"] = this.senderEntityId;
        data["senderEntityNameAr"] = this.senderEntityNameAr;
        data["senderEntityNameEn"] = this.senderEntityNameEn;
        data["transactionTypeNameAr"] = this.transactionTypeNameAr;
        data["transactionTypeNameEn"] = this.transactionTypeNameEn;
        data["transactionTypeId"] = this.transactionTypeId;
        data["sectorId"] = this.sectorId;
        data["sectorNameAr"] = this.sectorNameAr;
        data["sectorNameEn"] = this.sectorNameEn;
        data["currentDepartmentId"] = this.currentDepartmentId;
        data["currentDepartmentNameAr"] = this.currentDepartmentNameAr;
        data["currentDepartmentNameEn"] = this.currentDepartmentNameEn;
        data["receiverId"] = this.receiverId;
        data["receiverNameAr"] = this.receiverNameAr;
        data["receiverNameEn"] = this.receiverNameEn;
        data["responsibleEmployeeId"] = this.responsibleEmployeeId;
        data["responsibleEmployeeNameAr"] = this.responsibleEmployeeNameAr;
        data["responsibleEmployeeNameEn"] = this.responsibleEmployeeNameEn;
        data["documentId"] = this.documentId;
        data["documentNameAr"] = this.documentNameAr;
        data["documentNameEn"] = this.documentNameEn;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["receiptMethod"] = this.receiptMethod;
        data["accessLevel"] = this.accessLevel;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        if (Array.isArray(this.documentVersions)) {
            data["documentVersions"] = [];
            for (let item of this.documentVersions)
                data["documentVersions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncomingMailDto {
    id?: number;
    incomingNumber?: string | undefined;
    incomingDate?: Date | undefined;
    receivingTime?: string | undefined;
    senderLetterNumber?: string | undefined;
    receiptNumber?: string | undefined;
    folderId?: number;
    routingNotes?: string | undefined;
    senderLetterDate?: Date | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    senderEntityId?: number | undefined;
    senderEntityNameAr?: string | undefined;
    senderEntityNameEn?: string | undefined;
    transactionTypeNameAr?: string | undefined;
    transactionTypeNameEn?: string | undefined;
    transactionTypeId?: number | undefined;
    sectorId?: number | undefined;
    sectorNameAr?: string | undefined;
    sectorNameEn?: string | undefined;
    currentDepartmentId?: number | undefined;
    currentDepartmentNameAr?: string | undefined;
    currentDepartmentNameEn?: string | undefined;
    receiverId?: number | undefined;
    receiverNameAr?: string | undefined;
    receiverNameEn?: string | undefined;
    responsibleEmployeeId?: number | undefined;
    responsibleEmployeeNameAr?: string | undefined;
    responsibleEmployeeNameEn?: string | undefined;
    documentId?: number | undefined;
    documentNameAr?: string | undefined;
    documentNameEn?: string | undefined;
    secrecyLevel?: number | undefined;
    priority?: number | undefined;
    receiptMethod?: number | undefined;
    accessLevel?: number | undefined;
    keywords?: IncomingMailKeywordDto[] | undefined;
    documentVersions?: DocumentVersionIMGBase64Dto[] | undefined;
}

export class IncomingMailDtoServiceResponse implements IIncomingMailDtoServiceResponse {
    result?: IncomingMailDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IIncomingMailDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IncomingMailDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): IncomingMailDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IIncomingMailDtoServiceResponse {
    result?: IncomingMailDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class IncomingMailKeywordDto implements IIncomingMailKeywordDto {
    id?: number;
    incomingMailId?: number;
    keyword?: string | undefined;

    constructor(data?: IIncomingMailKeywordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incomingMailId = _data["incomingMailId"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): IncomingMailKeywordDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailKeywordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incomingMailId"] = this.incomingMailId;
        data["keyword"] = this.keyword;
        return data;
    }
}

export interface IIncomingMailKeywordDto {
    id?: number;
    incomingMailId?: number;
    keyword?: string | undefined;
}

export class IncomingMailPagedRequestDto implements IIncomingMailPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    incomingNumber?: string | undefined;
    documentId?: number | undefined;
    documentName?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IIncomingMailPagedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.incomingNumber = _data["incomingNumber"];
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncomingMailPagedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailPagedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["incomingNumber"] = this.incomingNumber;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIncomingMailPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    incomingNumber?: string | undefined;
    documentId?: number | undefined;
    documentName?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class IncomingMailPagedResponseDto implements IIncomingMailPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: IncomingMail[] | undefined;
    totalItems?: number;

    constructor(data?: IIncomingMailPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IncomingMail.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): IncomingMailPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IIncomingMailPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: IncomingMail[] | undefined;
    totalItems?: number;
}

export class IncomingMailPagedResponseDtoServiceResponse implements IIncomingMailPagedResponseDtoServiceResponse {
    result?: IncomingMailPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IIncomingMailPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IncomingMailPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): IncomingMailPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IIncomingMailPagedResponseDtoServiceResponse {
    result?: IncomingMailPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class IncomingMailUpdateDto implements IIncomingMailUpdateDto {
    id?: number;
    uploadedBy?: number | undefined;
    incomingDate?: Date;
    receivingTime?: string | undefined;
    senderEntityId?: number;
    documentId?: number;
    senderLetterNumber?: string | undefined;
    senderLetterDate?: Date;
    transactionTypeId?: number;
    secrecyLevel?: number;
    priority?: number;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    receiptMethod?: number;
    receiverId?: number;
    receiptNumber?: string | undefined;
    currentDepartmentId?: number;
    responsibleEmployeeId?: number | undefined;
    accessLevel?: number | undefined;
    routingNotes?: string | undefined;

    constructor(data?: IIncomingMailUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uploadedBy = _data["uploadedBy"];
            this.incomingDate = _data["incomingDate"] ? new Date(_data["incomingDate"].toString()) : <any>undefined;
            this.receivingTime = _data["receivingTime"];
            this.senderEntityId = _data["senderEntityId"];
            this.documentId = _data["documentId"];
            this.senderLetterNumber = _data["senderLetterNumber"];
            this.senderLetterDate = _data["senderLetterDate"] ? new Date(_data["senderLetterDate"].toString()) : <any>undefined;
            this.transactionTypeId = _data["transactionTypeId"];
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.sectorId = _data["sectorId"];
            this.relatedReference = _data["relatedReference"];
            this.linkedOutgoing = _data["linkedOutgoing"];
            this.receiptMethod = _data["receiptMethod"];
            this.receiverId = _data["receiverId"];
            this.receiptNumber = _data["receiptNumber"];
            this.currentDepartmentId = _data["currentDepartmentId"];
            this.responsibleEmployeeId = _data["responsibleEmployeeId"];
            this.accessLevel = _data["accessLevel"];
            this.routingNotes = _data["routingNotes"];
        }
    }

    static fromJS(data: any): IncomingMailUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uploadedBy"] = this.uploadedBy;
        data["incomingDate"] = this.incomingDate ? this.incomingDate.toISOString() : <any>undefined;
        data["receivingTime"] = this.receivingTime;
        data["senderEntityId"] = this.senderEntityId;
        data["documentId"] = this.documentId;
        data["senderLetterNumber"] = this.senderLetterNumber;
        data["senderLetterDate"] = this.senderLetterDate ? this.senderLetterDate.toISOString() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["sectorId"] = this.sectorId;
        data["relatedReference"] = this.relatedReference;
        data["linkedOutgoing"] = this.linkedOutgoing;
        data["receiptMethod"] = this.receiptMethod;
        data["receiverId"] = this.receiverId;
        data["receiptNumber"] = this.receiptNumber;
        data["currentDepartmentId"] = this.currentDepartmentId;
        data["responsibleEmployeeId"] = this.responsibleEmployeeId;
        data["accessLevel"] = this.accessLevel;
        data["routingNotes"] = this.routingNotes;
        return data;
    }
}

export interface IIncomingMailUpdateDto {
    id?: number;
    uploadedBy?: number | undefined;
    incomingDate?: Date;
    receivingTime?: string | undefined;
    senderEntityId?: number;
    documentId?: number;
    senderLetterNumber?: string | undefined;
    senderLetterDate?: Date;
    transactionTypeId?: number;
    secrecyLevel?: number;
    priority?: number;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    relatedReference?: string | undefined;
    linkedOutgoing?: string | undefined;
    receiptMethod?: number;
    receiverId?: number;
    receiptNumber?: string | undefined;
    currentDepartmentId?: number;
    responsibleEmployeeId?: number | undefined;
    accessLevel?: number | undefined;
    routingNotes?: string | undefined;
}

export class IncomingMailWithAttachmentsCreate implements IIncomingMailWithAttachmentsCreate {
    mailCreate?: IncomingMailCreateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IIncomingMailWithAttachmentsCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailCreate = _data["mailCreate"] ? IncomingMailCreateDto.fromJS(_data["mailCreate"]) : <any>undefined;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomingMailWithAttachmentsCreate {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailWithAttachmentsCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailCreate"] = this.mailCreate ? this.mailCreate.toJSON() : <any>undefined;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncomingMailWithAttachmentsCreate {
    mailCreate?: IncomingMailCreateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class IncomingMailWithAttachmentsUpdate implements IIncomingMailWithAttachmentsUpdate {
    mailUpdate?: IncomingMailUpdateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IIncomingMailWithAttachmentsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailUpdate = _data["mailUpdate"] ? IncomingMailUpdateDto.fromJS(_data["mailUpdate"]) : <any>undefined;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomingMailWithAttachmentsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingMailWithAttachmentsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailUpdate"] = this.mailUpdate ? this.mailUpdate.toJSON() : <any>undefined;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncomingMailWithAttachmentsUpdate {
    mailUpdate?: IncomingMailUpdateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class Int32NullableServiceResponse implements IInt32NullableServiceResponse {
    result?: number | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IInt32NullableServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): Int32NullableServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Int32NullableServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IInt32NullableServiceResponse {
    result?: number | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class Int64NullableServiceResponse implements IInt64NullableServiceResponse {
    result?: number | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IInt64NullableServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): Int64NullableServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Int64NullableServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IInt64NullableServiceResponse {
    result?: number | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class KeywordDto implements IKeywordDto {
    keywordName?: string | undefined;

    constructor(data?: IKeywordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keywordName = _data["keywordName"];
        }
    }

    static fromJS(data: any): KeywordDto {
        data = typeof data === 'object' ? data : {};
        let result = new KeywordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keywordName"] = this.keywordName;
        return data;
    }
}

export interface IKeywordDto {
    keywordName?: string | undefined;
}

export class LoginModel implements ILoginModel {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginModel {
    username?: string | undefined;
    password?: string | undefined;
}

export class LoginReaponse implements ILoginReaponse {
    token?: string | undefined;
    expires?: Date | undefined;
    expiryMinutes?: number;
    user?: User;

    constructor(data?: ILoginReaponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            this.expiryMinutes = _data["expiryMinutes"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginReaponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginReaponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["expiryMinutes"] = this.expiryMinutes;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginReaponse {
    token?: string | undefined;
    expires?: Date | undefined;
    expiryMinutes?: number;
    user?: User;
}

export class LoginReaponseServiceResponse implements ILoginReaponseServiceResponse {
    result?: LoginReaponse;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ILoginReaponseServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? LoginReaponse.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): LoginReaponseServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginReaponseServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ILoginReaponseServiceResponse {
    result?: LoginReaponse;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class MetadataFieldBulkCreateDto implements IMetadataFieldBulkCreateDto {
    id?: number | undefined;
    name?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    recordStatus?: number | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    documentType?: number | undefined;
    optionsArray?: string | undefined;
    nameEN?: string | undefined;

    constructor(data?: IMetadataFieldBulkCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.isRequired = _data["isRequired"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
            this.documentType = _data["documentType"];
            this.optionsArray = _data["optionsArray"];
            this.nameEN = _data["nameEN"];
        }
    }

    static fromJS(data: any): MetadataFieldBulkCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldBulkCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["isRequired"] = this.isRequired;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["optionsArray"] = this.optionsArray;
        data["nameEN"] = this.nameEN;
        return data;
    }
}

export interface IMetadataFieldBulkCreateDto {
    id?: number | undefined;
    name?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    recordStatus?: number | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    documentType?: number | undefined;
    optionsArray?: string | undefined;
    nameEN?: string | undefined;
}

export class MetadataFieldDto implements IMetadataFieldDto {
    id?: number;
    name?: string | undefined;
    optionsArray?: string | undefined;
    nameEN?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    documentType?: number | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IMetadataFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.optionsArray = _data["optionsArray"];
            this.nameEN = _data["nameEN"];
            this.dataType = _data["dataType"];
            this.isRequired = _data["isRequired"];
            this.documentType = _data["documentType"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MetadataFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["optionsArray"] = this.optionsArray;
        data["nameEN"] = this.nameEN;
        data["dataType"] = this.dataType;
        data["isRequired"] = this.isRequired;
        data["documentType"] = this.documentType;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMetadataFieldDto {
    id?: number;
    name?: string | undefined;
    optionsArray?: string | undefined;
    nameEN?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    documentType?: number | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class MetadataFieldDtoListServiceResponse implements IMetadataFieldDtoListServiceResponse {
    result?: MetadataFieldDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IMetadataFieldDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MetadataFieldDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): MetadataFieldDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IMetadataFieldDtoListServiceResponse {
    result?: MetadataFieldDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class MetadataFieldUpdateDto implements IMetadataFieldUpdateDto {
    id?: number;
    name?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    documentType?: string | undefined;
    recordStatus?: number;

    constructor(data?: IMetadataFieldUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.isRequired = _data["isRequired"];
            this.documentType = _data["documentType"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): MetadataFieldUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["isRequired"] = this.isRequired;
        data["documentType"] = this.documentType;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IMetadataFieldUpdateDto {
    id?: number;
    name?: string | undefined;
    dataType?: string | undefined;
    isRequired?: boolean | undefined;
    documentType?: string | undefined;
    recordStatus?: number;
}

export class MetadataFilterDto implements IMetadataFilterDto {
    fieldId?: number;
    value?: string | undefined;

    constructor(data?: IMetadataFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetadataFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["value"] = this.value;
        return data;
    }
}

export interface IMetadataFilterDto {
    fieldId?: number;
    value?: string | undefined;
}

export class ObjectServiceResponse implements IObjectServiceResponse {
    result?: any | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IObjectServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ObjectServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IObjectServiceResponse {
    result?: any | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class OutgoingMail implements IOutgoingMail {
    id?: number;
    outgoingNumber?: string | undefined;
    outgoingDate?: Date;
    transactionTypeId?: number;
    recipientEntityId?: number;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    actionTypeId?: number | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    reviewer?: number | undefined;
    approver?: number;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;
    documentId?: number;

    constructor(data?: IOutgoingMail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.outgoingNumber = _data["outgoingNumber"];
            this.outgoingDate = _data["outgoingDate"] ? new Date(_data["outgoingDate"].toString()) : <any>undefined;
            this.transactionTypeId = _data["transactionTypeId"];
            this.recipientEntityId = _data["recipientEntityId"];
            this.recipientContactPerson = _data["recipientContactPerson"];
            this.recipientContactInfo = _data["recipientContactInfo"];
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.preparingDepartmentId = _data["preparingDepartmentId"];
            this.linkedReference = _data["linkedReference"];
            this.linkedReferenceId = _data["linkedReferenceId"];
            this.subject = _data["subject"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.sectorId = _data["sectorId"];
            this.actionTypeId = _data["actionTypeId"];
            this.cc = _data["cc"];
            this.letterText = _data["letterText"];
            this.preparedBy = _data["preparedBy"];
            this.reviewer = _data["reviewer"];
            this.approver = _data["approver"];
            this.approvalPriority = _data["approvalPriority"];
            this.approvalExpiryDate = _data["approvalExpiryDate"] ? new Date(_data["approvalExpiryDate"].toString()) : <any>undefined;
            this.approvalNotes = _data["approvalNotes"];
            this.sendMethod = _data["sendMethod"];
            this.sendAddress = _data["sendAddress"];
            this.trackingNumber = _data["trackingNumber"];
            this.expectedSendDate = _data["expectedSendDate"] ? new Date(_data["expectedSendDate"].toString()) : <any>undefined;
            this.recipientName = _data["recipientName"];
            this.sendNotes = _data["sendNotes"];
            this.status = _data["status"];
            this.finalApprovalDate = _data["finalApprovalDate"] ? new Date(_data["finalApprovalDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): OutgoingMail {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["outgoingNumber"] = this.outgoingNumber;
        data["outgoingDate"] = this.outgoingDate ? this.outgoingDate.toISOString() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["recipientEntityId"] = this.recipientEntityId;
        data["recipientContactPerson"] = this.recipientContactPerson;
        data["recipientContactInfo"] = this.recipientContactInfo;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["preparingDepartmentId"] = this.preparingDepartmentId;
        data["linkedReference"] = this.linkedReference;
        data["linkedReferenceId"] = this.linkedReferenceId;
        data["subject"] = this.subject;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["sectorId"] = this.sectorId;
        data["actionTypeId"] = this.actionTypeId;
        data["cc"] = this.cc;
        data["letterText"] = this.letterText;
        data["preparedBy"] = this.preparedBy;
        data["reviewer"] = this.reviewer;
        data["approver"] = this.approver;
        data["approvalPriority"] = this.approvalPriority;
        data["approvalExpiryDate"] = this.approvalExpiryDate ? this.approvalExpiryDate.toISOString() : <any>undefined;
        data["approvalNotes"] = this.approvalNotes;
        data["sendMethod"] = this.sendMethod;
        data["sendAddress"] = this.sendAddress;
        data["trackingNumber"] = this.trackingNumber;
        data["expectedSendDate"] = this.expectedSendDate ? this.expectedSendDate.toISOString() : <any>undefined;
        data["recipientName"] = this.recipientName;
        data["sendNotes"] = this.sendNotes;
        data["status"] = this.status;
        data["finalApprovalDate"] = this.finalApprovalDate ? this.finalApprovalDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IOutgoingMail {
    id?: number;
    outgoingNumber?: string | undefined;
    outgoingDate?: Date;
    transactionTypeId?: number;
    recipientEntityId?: number;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    actionTypeId?: number | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    reviewer?: number | undefined;
    approver?: number;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;
    documentId?: number;
}

export class OutgoingMailCreateDto implements IOutgoingMailCreateDto {
    outgoingDate?: Date;
    transactionTypeId?: number;
    recipientEntityId?: number;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    actionTypeId?: number | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    reviewer?: number | undefined;
    approver?: number;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;

    constructor(data?: IOutgoingMailCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outgoingDate = _data["outgoingDate"] ? new Date(_data["outgoingDate"].toString()) : <any>undefined;
            this.transactionTypeId = _data["transactionTypeId"];
            this.recipientEntityId = _data["recipientEntityId"];
            this.recipientContactPerson = _data["recipientContactPerson"];
            this.recipientContactInfo = _data["recipientContactInfo"];
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.preparingDepartmentId = _data["preparingDepartmentId"];
            this.linkedReference = _data["linkedReference"];
            this.linkedReferenceId = _data["linkedReferenceId"];
            this.subject = _data["subject"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.sectorId = _data["sectorId"];
            this.actionTypeId = _data["actionTypeId"];
            this.cc = _data["cc"];
            this.letterText = _data["letterText"];
            this.preparedBy = _data["preparedBy"];
            this.reviewer = _data["reviewer"];
            this.approver = _data["approver"];
            this.approvalPriority = _data["approvalPriority"];
            this.approvalExpiryDate = _data["approvalExpiryDate"] ? new Date(_data["approvalExpiryDate"].toString()) : <any>undefined;
            this.approvalNotes = _data["approvalNotes"];
            this.sendMethod = _data["sendMethod"];
            this.sendAddress = _data["sendAddress"];
            this.trackingNumber = _data["trackingNumber"];
            this.expectedSendDate = _data["expectedSendDate"] ? new Date(_data["expectedSendDate"].toString()) : <any>undefined;
            this.recipientName = _data["recipientName"];
            this.sendNotes = _data["sendNotes"];
            this.status = _data["status"];
            this.finalApprovalDate = _data["finalApprovalDate"] ? new Date(_data["finalApprovalDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): OutgoingMailCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outgoingDate"] = this.outgoingDate ? this.outgoingDate.toISOString() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["recipientEntityId"] = this.recipientEntityId;
        data["recipientContactPerson"] = this.recipientContactPerson;
        data["recipientContactInfo"] = this.recipientContactInfo;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["preparingDepartmentId"] = this.preparingDepartmentId;
        data["linkedReference"] = this.linkedReference;
        data["linkedReferenceId"] = this.linkedReferenceId;
        data["subject"] = this.subject;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["sectorId"] = this.sectorId;
        data["actionTypeId"] = this.actionTypeId;
        data["cc"] = this.cc;
        data["letterText"] = this.letterText;
        data["preparedBy"] = this.preparedBy;
        data["reviewer"] = this.reviewer;
        data["approver"] = this.approver;
        data["approvalPriority"] = this.approvalPriority;
        data["approvalExpiryDate"] = this.approvalExpiryDate ? this.approvalExpiryDate.toISOString() : <any>undefined;
        data["approvalNotes"] = this.approvalNotes;
        data["sendMethod"] = this.sendMethod;
        data["sendAddress"] = this.sendAddress;
        data["trackingNumber"] = this.trackingNumber;
        data["expectedSendDate"] = this.expectedSendDate ? this.expectedSendDate.toISOString() : <any>undefined;
        data["recipientName"] = this.recipientName;
        data["sendNotes"] = this.sendNotes;
        data["status"] = this.status;
        data["finalApprovalDate"] = this.finalApprovalDate ? this.finalApprovalDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IOutgoingMailCreateDto {
    outgoingDate?: Date;
    transactionTypeId?: number;
    recipientEntityId?: number;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    actionTypeId?: number | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    reviewer?: number | undefined;
    approver?: number;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;
}

export class OutgoingMailDto implements IOutgoingMailDto {
    id?: number;
    outgoingNumber?: string | undefined;
    outgoingDate?: Date;
    transactionTypeId?: number;
    transactionTypeNameAr?: string | undefined;
    transactionTypeNameEn?: string | undefined;
    recipientEntityId?: number;
    recipientEntityNameAr?: string | undefined;
    recipientEntityNameEn?: string | undefined;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    preparingDepartmentNameAr?: string | undefined;
    preparingDepartmentNameEn?: string | undefined;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    sectorNameAr?: string | undefined;
    sectorNameEn?: string | undefined;
    actionTypeId?: number | undefined;
    actionTypeNameAr?: string | undefined;
    actionTypeNameEn?: string | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    preparedByNameAr?: string | undefined;
    preparedByNameEn?: string | undefined;
    reviewer?: number | undefined;
    reviewerNameAr?: string | undefined;
    reviewerNameEn?: string | undefined;
    approver?: number;
    approverNameAr?: string | undefined;
    approverNameEn?: string | undefined;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;
    createdByNameAr?: string | undefined;
    createdByNameEn?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    documentId?: number;
    documentNameAr?: string | undefined;
    documentNameEn?: string | undefined;
    folderId?: number;
    keywords?: OutgoingMailKeywordDto[] | undefined;
    documentVersions?: DocumentVersionIMGBase64Dto[] | undefined;

    constructor(data?: IOutgoingMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.outgoingNumber = _data["outgoingNumber"];
            this.outgoingDate = _data["outgoingDate"] ? new Date(_data["outgoingDate"].toString()) : <any>undefined;
            this.transactionTypeId = _data["transactionTypeId"];
            this.transactionTypeNameAr = _data["transactionTypeNameAr"];
            this.transactionTypeNameEn = _data["transactionTypeNameEn"];
            this.recipientEntityId = _data["recipientEntityId"];
            this.recipientEntityNameAr = _data["recipientEntityNameAr"];
            this.recipientEntityNameEn = _data["recipientEntityNameEn"];
            this.recipientContactPerson = _data["recipientContactPerson"];
            this.recipientContactInfo = _data["recipientContactInfo"];
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.preparingDepartmentId = _data["preparingDepartmentId"];
            this.preparingDepartmentNameAr = _data["preparingDepartmentNameAr"];
            this.preparingDepartmentNameEn = _data["preparingDepartmentNameEn"];
            this.linkedReference = _data["linkedReference"];
            this.linkedReferenceId = _data["linkedReferenceId"];
            this.subject = _data["subject"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.sectorId = _data["sectorId"];
            this.sectorNameAr = _data["sectorNameAr"];
            this.sectorNameEn = _data["sectorNameEn"];
            this.actionTypeId = _data["actionTypeId"];
            this.actionTypeNameAr = _data["actionTypeNameAr"];
            this.actionTypeNameEn = _data["actionTypeNameEn"];
            this.cc = _data["cc"];
            this.letterText = _data["letterText"];
            this.preparedBy = _data["preparedBy"];
            this.preparedByNameAr = _data["preparedByNameAr"];
            this.preparedByNameEn = _data["preparedByNameEn"];
            this.reviewer = _data["reviewer"];
            this.reviewerNameAr = _data["reviewerNameAr"];
            this.reviewerNameEn = _data["reviewerNameEn"];
            this.approver = _data["approver"];
            this.approverNameAr = _data["approverNameAr"];
            this.approverNameEn = _data["approverNameEn"];
            this.approvalPriority = _data["approvalPriority"];
            this.approvalExpiryDate = _data["approvalExpiryDate"] ? new Date(_data["approvalExpiryDate"].toString()) : <any>undefined;
            this.approvalNotes = _data["approvalNotes"];
            this.sendMethod = _data["sendMethod"];
            this.sendAddress = _data["sendAddress"];
            this.trackingNumber = _data["trackingNumber"];
            this.expectedSendDate = _data["expectedSendDate"] ? new Date(_data["expectedSendDate"].toString()) : <any>undefined;
            this.recipientName = _data["recipientName"];
            this.sendNotes = _data["sendNotes"];
            this.status = _data["status"];
            this.finalApprovalDate = _data["finalApprovalDate"] ? new Date(_data["finalApprovalDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByNameAr = _data["createdByNameAr"];
            this.createdByNameEn = _data["createdByNameEn"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.documentId = _data["documentId"];
            this.documentNameAr = _data["documentNameAr"];
            this.documentNameEn = _data["documentNameEn"];
            this.folderId = _data["folderId"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(OutgoingMailKeywordDto.fromJS(item));
            }
            if (Array.isArray(_data["documentVersions"])) {
                this.documentVersions = [] as any;
                for (let item of _data["documentVersions"])
                    this.documentVersions!.push(DocumentVersionIMGBase64Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutgoingMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["outgoingNumber"] = this.outgoingNumber;
        data["outgoingDate"] = this.outgoingDate ? this.outgoingDate.toISOString() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionTypeNameAr"] = this.transactionTypeNameAr;
        data["transactionTypeNameEn"] = this.transactionTypeNameEn;
        data["recipientEntityId"] = this.recipientEntityId;
        data["recipientEntityNameAr"] = this.recipientEntityNameAr;
        data["recipientEntityNameEn"] = this.recipientEntityNameEn;
        data["recipientContactPerson"] = this.recipientContactPerson;
        data["recipientContactInfo"] = this.recipientContactInfo;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["preparingDepartmentId"] = this.preparingDepartmentId;
        data["preparingDepartmentNameAr"] = this.preparingDepartmentNameAr;
        data["preparingDepartmentNameEn"] = this.preparingDepartmentNameEn;
        data["linkedReference"] = this.linkedReference;
        data["linkedReferenceId"] = this.linkedReferenceId;
        data["subject"] = this.subject;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["sectorId"] = this.sectorId;
        data["sectorNameAr"] = this.sectorNameAr;
        data["sectorNameEn"] = this.sectorNameEn;
        data["actionTypeId"] = this.actionTypeId;
        data["actionTypeNameAr"] = this.actionTypeNameAr;
        data["actionTypeNameEn"] = this.actionTypeNameEn;
        data["cc"] = this.cc;
        data["letterText"] = this.letterText;
        data["preparedBy"] = this.preparedBy;
        data["preparedByNameAr"] = this.preparedByNameAr;
        data["preparedByNameEn"] = this.preparedByNameEn;
        data["reviewer"] = this.reviewer;
        data["reviewerNameAr"] = this.reviewerNameAr;
        data["reviewerNameEn"] = this.reviewerNameEn;
        data["approver"] = this.approver;
        data["approverNameAr"] = this.approverNameAr;
        data["approverNameEn"] = this.approverNameEn;
        data["approvalPriority"] = this.approvalPriority;
        data["approvalExpiryDate"] = this.approvalExpiryDate ? this.approvalExpiryDate.toISOString() : <any>undefined;
        data["approvalNotes"] = this.approvalNotes;
        data["sendMethod"] = this.sendMethod;
        data["sendAddress"] = this.sendAddress;
        data["trackingNumber"] = this.trackingNumber;
        data["expectedSendDate"] = this.expectedSendDate ? this.expectedSendDate.toISOString() : <any>undefined;
        data["recipientName"] = this.recipientName;
        data["sendNotes"] = this.sendNotes;
        data["status"] = this.status;
        data["finalApprovalDate"] = this.finalApprovalDate ? this.finalApprovalDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByNameAr"] = this.createdByNameAr;
        data["createdByNameEn"] = this.createdByNameEn;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["documentId"] = this.documentId;
        data["documentNameAr"] = this.documentNameAr;
        data["documentNameEn"] = this.documentNameEn;
        data["folderId"] = this.folderId;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        if (Array.isArray(this.documentVersions)) {
            data["documentVersions"] = [];
            for (let item of this.documentVersions)
                data["documentVersions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOutgoingMailDto {
    id?: number;
    outgoingNumber?: string | undefined;
    outgoingDate?: Date;
    transactionTypeId?: number;
    transactionTypeNameAr?: string | undefined;
    transactionTypeNameEn?: string | undefined;
    recipientEntityId?: number;
    recipientEntityNameAr?: string | undefined;
    recipientEntityNameEn?: string | undefined;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    preparingDepartmentNameAr?: string | undefined;
    preparingDepartmentNameEn?: string | undefined;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    sectorNameAr?: string | undefined;
    sectorNameEn?: string | undefined;
    actionTypeId?: number | undefined;
    actionTypeNameAr?: string | undefined;
    actionTypeNameEn?: string | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    preparedByNameAr?: string | undefined;
    preparedByNameEn?: string | undefined;
    reviewer?: number | undefined;
    reviewerNameAr?: string | undefined;
    reviewerNameEn?: string | undefined;
    approver?: number;
    approverNameAr?: string | undefined;
    approverNameEn?: string | undefined;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;
    createdByNameAr?: string | undefined;
    createdByNameEn?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    documentId?: number;
    documentNameAr?: string | undefined;
    documentNameEn?: string | undefined;
    folderId?: number;
    keywords?: OutgoingMailKeywordDto[] | undefined;
    documentVersions?: DocumentVersionIMGBase64Dto[] | undefined;
}

export class OutgoingMailDtoServiceResponse implements IOutgoingMailDtoServiceResponse {
    result?: OutgoingMailDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IOutgoingMailDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OutgoingMailDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): OutgoingMailDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IOutgoingMailDtoServiceResponse {
    result?: OutgoingMailDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class OutgoingMailKeywordDto implements IOutgoingMailKeywordDto {
    id?: number;
    outgoingMailId?: number;
    keyword?: string | undefined;

    constructor(data?: IOutgoingMailKeywordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.outgoingMailId = _data["outgoingMailId"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): OutgoingMailKeywordDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailKeywordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["outgoingMailId"] = this.outgoingMailId;
        data["keyword"] = this.keyword;
        return data;
    }
}

export interface IOutgoingMailKeywordDto {
    id?: number;
    outgoingMailId?: number;
    keyword?: string | undefined;
}

export class OutgoingMailPagedRequestDto implements IOutgoingMailPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    outgoingNumber?: string | undefined;
    subject?: string | undefined;
    status?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    documentId?: number | undefined;
    documentName?: string | undefined;
    preparedBy?: number | undefined;
    approver?: number | undefined;

    constructor(data?: IOutgoingMailPagedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.outgoingNumber = _data["outgoingNumber"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.preparedBy = _data["preparedBy"];
            this.approver = _data["approver"];
        }
    }

    static fromJS(data: any): OutgoingMailPagedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailPagedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["outgoingNumber"] = this.outgoingNumber;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["preparedBy"] = this.preparedBy;
        data["approver"] = this.approver;
        return data;
    }
}

export interface IOutgoingMailPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    outgoingNumber?: string | undefined;
    subject?: string | undefined;
    status?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    documentId?: number | undefined;
    documentName?: string | undefined;
    preparedBy?: number | undefined;
    approver?: number | undefined;
}

export class OutgoingMailPagedResponseDto implements IOutgoingMailPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: OutgoingMail[] | undefined;
    totalItems?: number;

    constructor(data?: IOutgoingMailPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OutgoingMail.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): OutgoingMailPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IOutgoingMailPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: OutgoingMail[] | undefined;
    totalItems?: number;
}

export class OutgoingMailPagedResponseDtoServiceResponse implements IOutgoingMailPagedResponseDtoServiceResponse {
    result?: OutgoingMailPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IOutgoingMailPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OutgoingMailPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): OutgoingMailPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IOutgoingMailPagedResponseDtoServiceResponse {
    result?: OutgoingMailPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class OutgoingMailUpdateDto implements IOutgoingMailUpdateDto {
    outgoingDate?: Date;
    transactionTypeId?: number;
    recipientEntityId?: number;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    actionTypeId?: number | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    reviewer?: number | undefined;
    approver?: number;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;
    id?: number;
    documentId?: number;

    constructor(data?: IOutgoingMailUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outgoingDate = _data["outgoingDate"] ? new Date(_data["outgoingDate"].toString()) : <any>undefined;
            this.transactionTypeId = _data["transactionTypeId"];
            this.recipientEntityId = _data["recipientEntityId"];
            this.recipientContactPerson = _data["recipientContactPerson"];
            this.recipientContactInfo = _data["recipientContactInfo"];
            this.secrecyLevel = _data["secrecyLevel"];
            this.priority = _data["priority"];
            this.preparingDepartmentId = _data["preparingDepartmentId"];
            this.linkedReference = _data["linkedReference"];
            this.linkedReferenceId = _data["linkedReferenceId"];
            this.subject = _data["subject"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.sectorId = _data["sectorId"];
            this.actionTypeId = _data["actionTypeId"];
            this.cc = _data["cc"];
            this.letterText = _data["letterText"];
            this.preparedBy = _data["preparedBy"];
            this.reviewer = _data["reviewer"];
            this.approver = _data["approver"];
            this.approvalPriority = _data["approvalPriority"];
            this.approvalExpiryDate = _data["approvalExpiryDate"] ? new Date(_data["approvalExpiryDate"].toString()) : <any>undefined;
            this.approvalNotes = _data["approvalNotes"];
            this.sendMethod = _data["sendMethod"];
            this.sendAddress = _data["sendAddress"];
            this.trackingNumber = _data["trackingNumber"];
            this.expectedSendDate = _data["expectedSendDate"] ? new Date(_data["expectedSendDate"].toString()) : <any>undefined;
            this.recipientName = _data["recipientName"];
            this.sendNotes = _data["sendNotes"];
            this.status = _data["status"];
            this.finalApprovalDate = _data["finalApprovalDate"] ? new Date(_data["finalApprovalDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): OutgoingMailUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outgoingDate"] = this.outgoingDate ? this.outgoingDate.toISOString() : <any>undefined;
        data["transactionTypeId"] = this.transactionTypeId;
        data["recipientEntityId"] = this.recipientEntityId;
        data["recipientContactPerson"] = this.recipientContactPerson;
        data["recipientContactInfo"] = this.recipientContactInfo;
        data["secrecyLevel"] = this.secrecyLevel;
        data["priority"] = this.priority;
        data["preparingDepartmentId"] = this.preparingDepartmentId;
        data["linkedReference"] = this.linkedReference;
        data["linkedReferenceId"] = this.linkedReferenceId;
        data["subject"] = this.subject;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["sectorId"] = this.sectorId;
        data["actionTypeId"] = this.actionTypeId;
        data["cc"] = this.cc;
        data["letterText"] = this.letterText;
        data["preparedBy"] = this.preparedBy;
        data["reviewer"] = this.reviewer;
        data["approver"] = this.approver;
        data["approvalPriority"] = this.approvalPriority;
        data["approvalExpiryDate"] = this.approvalExpiryDate ? this.approvalExpiryDate.toISOString() : <any>undefined;
        data["approvalNotes"] = this.approvalNotes;
        data["sendMethod"] = this.sendMethod;
        data["sendAddress"] = this.sendAddress;
        data["trackingNumber"] = this.trackingNumber;
        data["expectedSendDate"] = this.expectedSendDate ? this.expectedSendDate.toISOString() : <any>undefined;
        data["recipientName"] = this.recipientName;
        data["sendNotes"] = this.sendNotes;
        data["status"] = this.status;
        data["finalApprovalDate"] = this.finalApprovalDate ? this.finalApprovalDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IOutgoingMailUpdateDto {
    outgoingDate?: Date;
    transactionTypeId?: number;
    recipientEntityId?: number;
    recipientContactPerson?: string | undefined;
    recipientContactInfo?: string | undefined;
    secrecyLevel?: string | undefined;
    priority?: string | undefined;
    preparingDepartmentId?: number;
    linkedReference?: string | undefined;
    linkedReferenceId?: number | undefined;
    subject?: string | undefined;
    dueDate?: Date | undefined;
    sectorId?: number | undefined;
    actionTypeId?: number | undefined;
    cc?: string | undefined;
    letterText?: string | undefined;
    preparedBy?: number;
    reviewer?: number | undefined;
    approver?: number;
    approvalPriority?: string | undefined;
    approvalExpiryDate?: Date | undefined;
    approvalNotes?: string | undefined;
    sendMethod?: string | undefined;
    sendAddress?: string | undefined;
    trackingNumber?: string | undefined;
    expectedSendDate?: Date | undefined;
    recipientName?: string | undefined;
    sendNotes?: string | undefined;
    status?: string | undefined;
    finalApprovalDate?: Date | undefined;
    sentDate?: Date | undefined;
    createdBy?: number;
    id?: number;
    documentId?: number;
}

export class OutgoingMailWithAttachmentsCreate implements IOutgoingMailWithAttachmentsCreate {
    mailCreate?: OutgoingMailCreateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IOutgoingMailWithAttachmentsCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailCreate = _data["mailCreate"] ? OutgoingMailCreateDto.fromJS(_data["mailCreate"]) : <any>undefined;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutgoingMailWithAttachmentsCreate {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailWithAttachmentsCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailCreate"] = this.mailCreate ? this.mailCreate.toJSON() : <any>undefined;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOutgoingMailWithAttachmentsCreate {
    mailCreate?: OutgoingMailCreateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class OutgoingMailWithAttachmentsUpdate implements IOutgoingMailWithAttachmentsUpdate {
    outgoingMailUpdate?: OutgoingMailUpdateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IOutgoingMailWithAttachmentsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outgoingMailUpdate = _data["outgoingMailUpdate"] ? OutgoingMailUpdateDto.fromJS(_data["outgoingMailUpdate"]) : <any>undefined;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutgoingMailWithAttachmentsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailWithAttachmentsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outgoingMailUpdate"] = this.outgoingMailUpdate ? this.outgoingMailUpdate.toJSON() : <any>undefined;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOutgoingMailWithAttachmentsUpdate {
    outgoingMailUpdate?: OutgoingMailUpdateDto;
    keywords?: KeywordDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class PagedRequestDto implements IPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;

    constructor(data?: IPagedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): PagedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        return data;
    }
}

export interface IPagedRequestDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
}

export class PermissionsCreateDto implements IPermissionsCreateDto {
    entityType?: string | undefined;
    entityId?: number | undefined;
    canView?: boolean | undefined;
    canEdit?: boolean | undefined;
    canDelete?: boolean | undefined;
    canDownload?: boolean | undefined;
    canShare?: boolean | undefined;
    recordStatus?: number;

    constructor(data?: IPermissionsCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.canView = _data["canView"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
            this.canDownload = _data["canDownload"];
            this.canShare = _data["canShare"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): PermissionsCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["canView"] = this.canView;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        data["canDownload"] = this.canDownload;
        data["canShare"] = this.canShare;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IPermissionsCreateDto {
    entityType?: string | undefined;
    entityId?: number | undefined;
    canView?: boolean | undefined;
    canEdit?: boolean | undefined;
    canDelete?: boolean | undefined;
    canDownload?: boolean | undefined;
    canShare?: boolean | undefined;
    recordStatus?: number;
}

export class PermissionsDto implements IPermissionsDto {
    id?: number;
    entityType?: string | undefined;
    entityId?: number;
    canView?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
    canDownload?: boolean;
    canShare?: boolean;
    userId?: number;

    constructor(data?: IPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.canView = _data["canView"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
            this.canDownload = _data["canDownload"];
            this.canShare = _data["canShare"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): PermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["canView"] = this.canView;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        data["canDownload"] = this.canDownload;
        data["canShare"] = this.canShare;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IPermissionsDto {
    id?: number;
    entityType?: string | undefined;
    entityId?: number;
    canView?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
    canDownload?: boolean;
    canShare?: boolean;
    userId?: number;
}

export class PermissionsDtoListServiceResponse implements IPermissionsDtoListServiceResponse {
    result?: PermissionsDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IPermissionsDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PermissionsDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PermissionsDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IPermissionsDtoListServiceResponse {
    result?: PermissionsDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class PermissionsDtoServiceResponse implements IPermissionsDtoServiceResponse {
    result?: PermissionsDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IPermissionsDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PermissionsDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PermissionsDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IPermissionsDtoServiceResponse {
    result?: PermissionsDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class PermissionsUpdateDto implements IPermissionsUpdateDto {
    id?: number;
    entityType?: string | undefined;
    entityId?: number | undefined;
    canView?: boolean | undefined;
    canEdit?: boolean | undefined;
    canDelete?: boolean | undefined;
    canDownload?: boolean | undefined;
    canShare?: boolean | undefined;
    recordStatus?: number;

    constructor(data?: IPermissionsUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.canView = _data["canView"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
            this.canDownload = _data["canDownload"];
            this.canShare = _data["canShare"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): PermissionsUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["canView"] = this.canView;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        data["canDownload"] = this.canDownload;
        data["canShare"] = this.canShare;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IPermissionsUpdateDto {
    id?: number;
    entityType?: string | undefined;
    entityId?: number | undefined;
    canView?: boolean | undefined;
    canEdit?: boolean | undefined;
    canDelete?: boolean | undefined;
    canDownload?: boolean | undefined;
    canShare?: boolean | undefined;
    recordStatus?: number;
}

export class RoleCreateDto implements IRoleCreateDto {
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;

    constructor(data?: IRoleCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): RoleCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IRoleCreateDto {
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;
}

export class RoleUpdateDto implements IRoleUpdateDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;

    constructor(data?: IRoleUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): RoleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IRoleUpdateDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;
}

export class SectorCreateDto implements ISectorCreateDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    recordStatus?: number;

    constructor(data?: ISectorCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.isActive = _data["isActive"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): SectorCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["isActive"] = this.isActive;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ISectorCreateDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    recordStatus?: number;
}

export class SectorDto implements ISectorDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    createdAt?: Date | undefined;
    recordStatus?: number | undefined;

    constructor(data?: ISectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): SectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ISectorDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    createdAt?: Date | undefined;
    recordStatus?: number | undefined;
}

export class SectorDtoListServiceResponse implements ISectorDtoListServiceResponse {
    result?: SectorDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ISectorDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SectorDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SectorDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ISectorDtoListServiceResponse {
    result?: SectorDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class SectorDtoPagedResponseDto implements ISectorDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: SectorDto[] | undefined;
    totalItems?: number;

    constructor(data?: ISectorDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SectorDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): SectorDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface ISectorDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: SectorDto[] | undefined;
    totalItems?: number;
}

export class SectorDtoPagedResponseDtoServiceResponse implements ISectorDtoPagedResponseDtoServiceResponse {
    result?: SectorDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ISectorDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SectorDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SectorDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ISectorDtoPagedResponseDtoServiceResponse {
    result?: SectorDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class SectorDtoServiceResponse implements ISectorDtoServiceResponse {
    result?: SectorDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ISectorDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SectorDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SectorDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ISectorDtoServiceResponse {
    result?: SectorDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class SectorFilterDto implements ISectorFilterDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;

    constructor(data?: ISectorFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
        }
    }

    static fromJS(data: any): SectorFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        return data;
    }
}

export interface ISectorFilterDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;
}

export class SectorUpdateDto implements ISectorUpdateDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    recordStatus?: number;

    constructor(data?: ISectorUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.isActive = _data["isActive"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): SectorUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["isActive"] = this.isActive;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ISectorUpdateDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    recordStatus?: number;
}

export class SenderEntityCreateDto implements ISenderEntityCreateDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISenderEntityCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SenderEntityCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISenderEntityCreateDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
}

export class SenderEntityDto implements ISenderEntityDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    createdAt?: Date;
    recordStatus?: number;

    constructor(data?: ISenderEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): SenderEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ISenderEntityDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    createdAt?: Date;
    recordStatus?: number;
}

export class SenderEntityDtoListServiceResponse implements ISenderEntityDtoListServiceResponse {
    result?: SenderEntityDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ISenderEntityDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SenderEntityDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SenderEntityDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ISenderEntityDtoListServiceResponse {
    result?: SenderEntityDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class SenderEntityDtoPagedResponseDto implements ISenderEntityDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: SenderEntityDto[] | undefined;
    totalItems?: number;

    constructor(data?: ISenderEntityDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SenderEntityDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): SenderEntityDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface ISenderEntityDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: SenderEntityDto[] | undefined;
    totalItems?: number;
}

export class SenderEntityDtoPagedResponseDtoServiceResponse implements ISenderEntityDtoPagedResponseDtoServiceResponse {
    result?: SenderEntityDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ISenderEntityDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SenderEntityDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SenderEntityDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ISenderEntityDtoPagedResponseDtoServiceResponse {
    result?: SenderEntityDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class SenderEntityDtoServiceResponse implements ISenderEntityDtoServiceResponse {
    result?: SenderEntityDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ISenderEntityDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SenderEntityDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SenderEntityDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ISenderEntityDtoServiceResponse {
    result?: SenderEntityDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class SenderEntityFilterDto implements ISenderEntityFilterDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;

    constructor(data?: ISenderEntityFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
        }
    }

    static fromJS(data: any): SenderEntityFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        return data;
    }
}

export interface ISenderEntityFilterDto {
    nameAr?: string | undefined;
    nameEn?: string | undefined;
}

export class SenderEntityUpdateDto implements ISenderEntityUpdateDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISenderEntityUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SenderEntityUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenderEntityUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISenderEntityUpdateDto {
    id?: number;
    nameAr?: string | undefined;
    nameEn?: string | undefined;
    isActive?: boolean;
}

export class SharedLinkCreateDto implements ISharedLinkCreateDto {
    documentVersionId?: number;
    key?: string | undefined;
    expireDate?: string | undefined;
    createdBy?: number;
    url?: string | undefined;

    constructor(data?: ISharedLinkCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentVersionId = _data["documentVersionId"];
            this.key = _data["key"];
            this.expireDate = _data["expireDate"];
            this.createdBy = _data["createdBy"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SharedLinkCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharedLinkCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentVersionId"] = this.documentVersionId;
        data["key"] = this.key;
        data["expireDate"] = this.expireDate;
        data["createdBy"] = this.createdBy;
        data["url"] = this.url;
        return data;
    }
}

export interface ISharedLinkCreateDto {
    documentVersionId?: number;
    key?: string | undefined;
    expireDate?: string | undefined;
    createdBy?: number;
    url?: string | undefined;
}

export class SharedLinkDto implements ISharedLinkDto {
    id?: number;
    documentVersionId?: number;
    key?: string | undefined;
    url?: string | undefined;
    expireDate?: Date;
    createDate?: Date;
    createdBy?: number;

    constructor(data?: ISharedLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentVersionId = _data["documentVersionId"];
            this.key = _data["key"];
            this.url = _data["url"];
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): SharedLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharedLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentVersionId"] = this.documentVersionId;
        data["key"] = this.key;
        data["url"] = this.url;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface ISharedLinkDto {
    id?: number;
    documentVersionId?: number;
    key?: string | undefined;
    url?: string | undefined;
    expireDate?: Date;
    createDate?: Date;
    createdBy?: number;
}

export class SharedLinkDtoServiceResponse implements ISharedLinkDtoServiceResponse {
    result?: SharedLinkDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ISharedLinkDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SharedLinkDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SharedLinkDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SharedLinkDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ISharedLinkDtoServiceResponse {
    result?: SharedLinkDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class StringServiceResponse implements IStringServiceResponse {
    result?: string | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IStringServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): StringServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StringServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IStringServiceResponse {
    result?: string | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class TagsCreateDto implements ITagsCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    color?: string | undefined;
    recordStatus?: number;

    constructor(data?: ITagsCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.color = _data["color"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): TagsCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagsCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["color"] = this.color;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ITagsCreateDto {
    name?: string | undefined;
    nameEN?: string | undefined;
    color?: string | undefined;
    recordStatus?: number;
}

export class TagsDto implements ITagsDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    color?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: ITagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.color = _data["color"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["color"] = this.color;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITagsDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    color?: string | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class TagsDtoListServiceResponse implements ITagsDtoListServiceResponse {
    result?: TagsDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ITagsDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TagsDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): TagsDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagsDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ITagsDtoListServiceResponse {
    result?: TagsDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class TagsDtoPagedResponseDto implements ITagsDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: TagsDto[] | undefined;
    totalItems?: number;

    constructor(data?: ITagsDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TagsDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): TagsDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagsDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface ITagsDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: TagsDto[] | undefined;
    totalItems?: number;
}

export class TagsDtoPagedResponseDtoServiceResponse implements ITagsDtoPagedResponseDtoServiceResponse {
    result?: TagsDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ITagsDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TagsDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): TagsDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagsDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ITagsDtoPagedResponseDtoServiceResponse {
    result?: TagsDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class TagsDtoServiceResponse implements ITagsDtoServiceResponse {
    result?: TagsDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ITagsDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TagsDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): TagsDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagsDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ITagsDtoServiceResponse {
    result?: TagsDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class TagsUpdateDto implements ITagsUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    color?: string | undefined;
    recordStatus?: number;

    constructor(data?: ITagsUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEN = _data["nameEN"];
            this.color = _data["color"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): TagsUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagsUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEN"] = this.nameEN;
        data["color"] = this.color;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ITagsUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEN?: string | undefined;
    color?: string | undefined;
    recordStatus?: number;
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    readonly days?: number;
    readonly hours?: number;
    readonly milliseconds?: number;
    readonly microseconds?: number;
    readonly nanoseconds?: number;
    readonly minutes?: number;
    readonly seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMicroseconds?: number;
    readonly totalNanoseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).microseconds = _data["microseconds"];
            (<any>this).nanoseconds = _data["nanoseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMicroseconds = _data["totalMicroseconds"];
            (<any>this).totalNanoseconds = _data["totalNanoseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["microseconds"] = this.microseconds;
        data["nanoseconds"] = this.nanoseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMicroseconds"] = this.totalMicroseconds;
        data["totalNanoseconds"] = this.totalNanoseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    microseconds?: number;
    nanoseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMicroseconds?: number;
    totalNanoseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class TransactionTypeCreateDto implements ITransactionTypeCreateDto {
    name?: string | undefined;
    nameEn?: string | undefined;
    recordStatus?: number;

    constructor(data?: ITransactionTypeCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): TransactionTypeCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ITransactionTypeCreateDto {
    name?: string | undefined;
    nameEn?: string | undefined;
    recordStatus?: number;
}

export class TransactionTypeDto implements ITransactionTypeDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: ITransactionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): TransactionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ITransactionTypeDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    recordStatus?: number;
}

export class TransactionTypeDtoListServiceResponse implements ITransactionTypeDtoListServiceResponse {
    result?: TransactionTypeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ITransactionTypeDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TransactionTypeDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): TransactionTypeDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ITransactionTypeDtoListServiceResponse {
    result?: TransactionTypeDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class TransactionTypeDtoPagedResponseDto implements ITransactionTypeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: TransactionTypeDto[] | undefined;
    totalItems?: number;

    constructor(data?: ITransactionTypeDtoPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionTypeDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): TransactionTypeDtoPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDtoPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface ITransactionTypeDtoPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: TransactionTypeDto[] | undefined;
    totalItems?: number;
}

export class TransactionTypeDtoPagedResponseDtoServiceResponse implements ITransactionTypeDtoPagedResponseDtoServiceResponse {
    result?: TransactionTypeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ITransactionTypeDtoPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TransactionTypeDtoPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): TransactionTypeDtoPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDtoPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ITransactionTypeDtoPagedResponseDtoServiceResponse {
    result?: TransactionTypeDtoPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class TransactionTypeDtoServiceResponse implements ITransactionTypeDtoServiceResponse {
    result?: TransactionTypeDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: ITransactionTypeDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TransactionTypeDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): TransactionTypeDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface ITransactionTypeDtoServiceResponse {
    result?: TransactionTypeDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class TransactionTypeUpdateDto implements ITransactionTypeUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: ITransactionTypeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameEn = _data["nameEn"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): TransactionTypeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameEn"] = this.nameEn;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface ITransactionTypeUpdateDto {
    id?: number;
    name?: string | undefined;
    nameEn?: string | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
}

export class User implements IUser {
    id?: number;
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean | undefined;
    createdAt?: Date | undefined;
    lastLoginAt?: Date | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    profileImage?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.departmentId = _data["departmentId"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.lastLoginAt = _data["lastLoginAt"] ? new Date(_data["lastLoginAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["departmentId"] = this.departmentId;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface IUser {
    id?: number;
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean | undefined;
    createdAt?: Date | undefined;
    lastLoginAt?: Date | undefined;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    profileImage?: string | undefined;
}

export class UserCreateDto implements IUserCreateDto {
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phone?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
    profileImage?: string | undefined;

    constructor(data?: IUserCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.phone = _data["phone"];
            this.departmentId = _data["departmentId"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): UserCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["phone"] = this.phone;
        data["departmentId"] = this.departmentId;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface IUserCreateDto {
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phone?: string | undefined;
    departmentId?: number | undefined;
    isActive?: boolean | undefined;
    createdAt?: Date | undefined;
    recordStatus?: number;
    profileImage?: string | undefined;
}

export class UserCreateWithPermissionsDto implements IUserCreateWithPermissionsDto {
    user?: UserCreateDto;
    permissions?: PermissionsDto[] | undefined;

    constructor(data?: IUserCreateWithPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserCreateDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserCreateWithPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateWithPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserCreateWithPermissionsDto {
    user?: UserCreateDto;
    permissions?: PermissionsDto[] | undefined;
}

export class UserListServiceResponse implements IUserListServiceResponse {
    result?: User[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IUserListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(User.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UserListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IUserListServiceResponse {
    result?: User[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class UserPagedResponseDto implements IUserPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: User[] | undefined;
    totalItems?: number;

    constructor(data?: IUserPagedResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(User.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): UserPagedResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPagedResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IUserPagedResponseDto {
    pageNumber?: number;
    pageSize?: number;
    search?: string | undefined;
    data?: User[] | undefined;
    totalItems?: number;
}

export class UserPagedResponseDtoServiceResponse implements IUserPagedResponseDtoServiceResponse {
    result?: UserPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IUserPagedResponseDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? UserPagedResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UserPagedResponseDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserPagedResponseDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IUserPagedResponseDtoServiceResponse {
    result?: UserPagedResponseDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class UserRoleCreateDto implements IUserRoleCreateDto {
    userId?: number;
    roleId?: number;
    recordStatus?: number;

    constructor(data?: IUserRoleCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): UserRoleCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IUserRoleCreateDto {
    userId?: number;
    roleId?: number;
    recordStatus?: number;
}

export class UserRoleDto implements IUserRoleDto {
    userId?: number;
    roleId?: number;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.recordStatus = _data["recordStatus"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["recordStatus"] = this.recordStatus;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserRoleDto {
    userId?: number;
    roleId?: number;
    recordStatus?: number;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
}

export class UserRoleDtoListServiceResponse implements IUserRoleDtoListServiceResponse {
    result?: UserRoleDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IUserRoleDtoListServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserRoleDto.fromJS(item));
            }
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UserRoleDtoListServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDtoListServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IUserRoleDtoListServiceResponse {
    result?: UserRoleDto[] | undefined;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class UserRoleDtoServiceResponse implements IUserRoleDtoServiceResponse {
    result?: UserRoleDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IUserRoleDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? UserRoleDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UserRoleDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IUserRoleDtoServiceResponse {
    result?: UserRoleDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class UserRoleResult implements IUserRoleResult {
    userId?: number;
    roleId?: number;

    constructor(data?: IUserRoleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRoleResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUserRoleResult {
    userId?: number;
    roleId?: number;
}

export class UserRoleResultServiceResponse implements IUserRoleResultServiceResponse {
    result?: UserRoleResult;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IUserRoleResultServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? UserRoleResult.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UserRoleResultServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleResultServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IUserRoleResultServiceResponse {
    result?: UserRoleResult;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class UserSelectRequest implements IUserSelectRequest {
    id?: number | undefined;
    username?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserSelectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserSelectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserSelectRequest {
    id?: number | undefined;
    username?: string | undefined;
    email?: string | undefined;
}

export class UserServiceResponse implements IUserServiceResponse {
    result?: User;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IUserServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? User.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UserServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IUserServiceResponse {
    result?: User;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class UserUpdateDto implements IUserUpdateDto {
    id?: number;
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    departmentId?: number | undefined;
    profileImage?: string | undefined;

    constructor(data?: IUserUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.departmentId = _data["departmentId"];
            this.profileImage = _data["profileImage"];
        }
    }

    static fromJS(data: any): UserUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["departmentId"] = this.departmentId;
        data["profileImage"] = this.profileImage;
        return data;
    }
}

export interface IUserUpdateDto {
    id?: number;
    username?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    departmentId?: number | undefined;
    profileImage?: string | undefined;
}

export class UserUpdateWithPermissionsDto implements IUserUpdateWithPermissionsDto {
    user?: UserUpdateDto;
    permissions?: PermissionsDto[] | undefined;

    constructor(data?: IUserUpdateWithPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserUpdateDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserUpdateWithPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateWithPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserUpdateWithPermissionsDto {
    user?: UserUpdateDto;
    permissions?: PermissionsDto[] | undefined;
}

export class UserWithPermissionsDto implements IUserWithPermissionsDto {
    user?: User;
    permissions?: PermissionsDto[] | undefined;

    constructor(data?: IUserWithPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserWithPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserWithPermissionsDto {
    user?: User;
    permissions?: PermissionsDto[] | undefined;
}

export class UserWithPermissionsDtoServiceResponse implements IUserWithPermissionsDtoServiceResponse {
    result?: UserWithPermissionsDto;
    responseCodes?: string | undefined;
    success?: boolean;

    constructor(data?: IUserWithPermissionsDtoServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? UserWithPermissionsDto.fromJS(_data["result"]) : <any>undefined;
            this.responseCodes = _data["responseCodes"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UserWithPermissionsDtoServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithPermissionsDtoServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["responseCodes"] = this.responseCodes;
        data["success"] = this.success;
        return data;
    }
}

export interface IUserWithPermissionsDtoServiceResponse {
    result?: UserWithPermissionsDto;
    responseCodes?: string | undefined;
    success?: boolean;
}

export class WorkflowCreateDto implements IWorkflowCreateDto {
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;

    constructor(data?: IWorkflowCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): WorkflowCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IWorkflowCreateDto {
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;
}

export class WorkflowInstanceCreateDto implements IWorkflowInstanceCreateDto {
    documentId?: number | undefined;
    workflowId?: number | undefined;
    currentStep?: number | undefined;
    status?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: IWorkflowInstanceCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.workflowId = _data["workflowId"];
            this.currentStep = _data["currentStep"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): WorkflowInstanceCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowInstanceCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["workflowId"] = this.workflowId;
        data["currentStep"] = this.currentStep;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IWorkflowInstanceCreateDto {
    documentId?: number | undefined;
    workflowId?: number | undefined;
    currentStep?: number | undefined;
    status?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    recordStatus?: number;
}

export class WorkflowInstanceUpdateDto implements IWorkflowInstanceUpdateDto {
    id?: number;
    documentId?: number | undefined;
    workflowId?: number | undefined;
    currentStep?: number | undefined;
    status?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    recordStatus?: number;

    constructor(data?: IWorkflowInstanceUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.workflowId = _data["workflowId"];
            this.currentStep = _data["currentStep"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): WorkflowInstanceUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowInstanceUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["workflowId"] = this.workflowId;
        data["currentStep"] = this.currentStep;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IWorkflowInstanceUpdateDto {
    id?: number;
    documentId?: number | undefined;
    workflowId?: number | undefined;
    currentStep?: number | undefined;
    status?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    recordStatus?: number;
}

export class WorkflowStepCreateDto implements IWorkflowStepCreateDto {
    workflowId?: number | undefined;
    stepOrder?: number | undefined;
    roleId?: number | undefined;
    actionName?: string | undefined;
    recordStatus?: number;

    constructor(data?: IWorkflowStepCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.stepOrder = _data["stepOrder"];
            this.roleId = _data["roleId"];
            this.actionName = _data["actionName"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): WorkflowStepCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowStepCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["stepOrder"] = this.stepOrder;
        data["roleId"] = this.roleId;
        data["actionName"] = this.actionName;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IWorkflowStepCreateDto {
    workflowId?: number | undefined;
    stepOrder?: number | undefined;
    roleId?: number | undefined;
    actionName?: string | undefined;
    recordStatus?: number;
}

export class WorkflowStepUpdateDto implements IWorkflowStepUpdateDto {
    id?: number;
    workflowId?: number | undefined;
    stepOrder?: number | undefined;
    roleId?: number | undefined;
    actionName?: string | undefined;
    recordStatus?: number;

    constructor(data?: IWorkflowStepUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workflowId = _data["workflowId"];
            this.stepOrder = _data["stepOrder"];
            this.roleId = _data["roleId"];
            this.actionName = _data["actionName"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): WorkflowStepUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowStepUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workflowId"] = this.workflowId;
        data["stepOrder"] = this.stepOrder;
        data["roleId"] = this.roleId;
        data["actionName"] = this.actionName;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IWorkflowStepUpdateDto {
    id?: number;
    workflowId?: number | undefined;
    stepOrder?: number | undefined;
    roleId?: number | undefined;
    actionName?: string | undefined;
    recordStatus?: number;
}

export class WorkflowUpdateDto implements IWorkflowUpdateDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;

    constructor(data?: IWorkflowUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): WorkflowUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["recordStatus"] = this.recordStatus;
        return data;
    }
}

export interface IWorkflowUpdateDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    recordStatus?: number;
}

export class RequestCreateDto implements IRequestCreateDto {
    documentTypeCreateDto?: DocumentTypeCreateDto;
    metadataFieldCreateDto?: MetadataFieldBulkCreateDto[] | undefined;

    constructor(data?: IRequestCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeCreateDto = _data["documentTypeCreateDto"] ? DocumentTypeCreateDto.fromJS(_data["documentTypeCreateDto"]) : <any>undefined;
            if (Array.isArray(_data["metadataFieldCreateDto"])) {
                this.metadataFieldCreateDto = [] as any;
                for (let item of _data["metadataFieldCreateDto"])
                    this.metadataFieldCreateDto!.push(MetadataFieldBulkCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeCreateDto"] = this.documentTypeCreateDto ? this.documentTypeCreateDto.toJSON() : <any>undefined;
        if (Array.isArray(this.metadataFieldCreateDto)) {
            data["metadataFieldCreateDto"] = [];
            for (let item of this.metadataFieldCreateDto)
                data["metadataFieldCreateDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestCreateDto {
    documentTypeCreateDto?: DocumentTypeCreateDto;
    metadataFieldCreateDto?: MetadataFieldBulkCreateDto[] | undefined;
}

export class RequestUpdateDto implements IRequestUpdateDto {
    documentTypeUpdateDto?: DocumentTypeUpdateDto;
    metadataFieldCreateDto?: MetadataFieldBulkCreateDto[] | undefined;

    constructor(data?: IRequestUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeUpdateDto = _data["documentTypeUpdateDto"] ? DocumentTypeUpdateDto.fromJS(_data["documentTypeUpdateDto"]) : <any>undefined;
            if (Array.isArray(_data["metadataFieldCreateDto"])) {
                this.metadataFieldCreateDto = [] as any;
                for (let item of _data["metadataFieldCreateDto"])
                    this.metadataFieldCreateDto!.push(MetadataFieldBulkCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeUpdateDto"] = this.documentTypeUpdateDto ? this.documentTypeUpdateDto.toJSON() : <any>undefined;
        if (Array.isArray(this.metadataFieldCreateDto)) {
            data["metadataFieldCreateDto"] = [];
            for (let item of this.metadataFieldCreateDto)
                data["metadataFieldCreateDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestUpdateDto {
    documentTypeUpdateDto?: DocumentTypeUpdateDto;
    metadataFieldCreateDto?: MetadataFieldBulkCreateDto[] | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}